<!-- faisal pdf services work start -->
<div class="container-fluid">


  <div class="container p-0 max-w-h s-bg-img my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <!-- <div class="b-bottom"></div> -->
        </div>
        <div class="d-flex justify-content-center">
          <div class="s-flex">
            <h1 class="s-main">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوط</h1>
            <h6 class="s-semi">لسعادة البشرية،</h6>
            <p class="s-p-txt">(يرغب في الحب ونيل المن)</p>
            <p class="s-p-txt">2025نتيجة </p>
          </div>
        </div>
      </div>
      <div class="s-footer pos-rel-pdf">
        <div class="c-f-img-1">
          <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
        </div>
        <div class="c-f-img-2">
          <img class="c-f-img-2-pic" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
        </div>
        <div class="s-footer-flex">
          <p class="s-footer-txt-1">سعاده فيما نتحم</p>
          <p class="s-footer-txt-2">سعادة، ولكن بفضل هؤلاء الأشخاص الذين ل</p>
        </div>
      </div>

    </div>
  </div>

  <div class="container p-0 max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <!-- <div class="b-bottom"></div> -->
        </div>
        <div class="d-flex justify-content-center">
          <div class="s-flex">
            <h1 class="s-main">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوط</h1>
            <h6 class="s-semi">لسعادة البشرية،</h6>
            <p class="s-p-txt">(يرغب في الحب ونيل المن)</p>
            <p class="s-p-txt">2025نتيجة </p>
          </div>
        </div>
      </div>
      <div class="s-footer pos-rel-pdf">
        <div class="c-f-img-1">
          <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
        </div>
        <div class="c-f-img-2">
          <img class="c-f-img-2-pic" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
        </div>
        <div class="s-footer-flex">
          <p class="s-footer-txt-1">سعاده فيما نتحم</p>
          <p class="s-footer-txt-2">سعادة، ولكن بفضل هؤلاء الأشخاص الذين ل</p>
        </div>
      </div>

    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-service">
      <div class="d-flex flex-column">
        <img class="w-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="p-3rem">

          <div class="d-flex flex-column">
            <h4 class="my-5">:ةمدقم </h4>
            <p class="pdf-text-white">
              تامدخلا ةدوج عفرو هيبوسنمل ةيفرعملا تاردقلا ءانب يف لامعلأل يدوعسلا زكرملا هجوت نم ًاقلاطنا
              زيزعت فدهب تاهجلا تامدخل تامولعملا ليلد ءانب ىلع لمعلا مت دقف ،زكرملا يف نيرمثتسملل ةمدقملا
              تامدخ يفظوم ىدل يفرعملا ءانبلا ةلماشلا تارابتخلال اردصم نوكيس امك ،لامعلأا عاطقو نيرمثتسملا
              ا ًقفو نيسحتلل ةلباقلا نماكملا ةفرعمو فظوملا ءادأ سايق فدهب ماعلا للاخ يرود لكشب دقعنتس يتلا
              لاجم يف تاسرامملا لضفأ قيبطت نم فظوملا نكمتي ىتح اهريوطتو اهيلع لمعلاو ،تاجرخملاو جئاتنلل
              ثتسملا ةمدخ ةمدخلا ميدقت ءانثأ ةقدلا يرحتو نيرم <br>
              <br>
              نامضل اهتاباجإو ةلئسلأا ميكحت متو ةيموكحلا تاهجلا يف نيراشتسملا نم ةعومجم للاخ نم ليلدلا ينب
              ةيقوثوم ىلعأ ، نم ليلدلا نوكتيو 9 ةعومجم ىلع يوتحيو ةيموكحلا ةهجلا مساب نونعم ءزج لك ،ءازجأ
              .زكرملا يف مدقت يتلا تامدخلا لاجم يف اهتاباجإو ةلئسلأا نم
              ،نيفظوملل لماشلا رابتخلاا ءانب اهرارغ ىلع متيس يتلا ةلئسلأا جذامن نم ةعومجم ءزج لك نمضتي امك
              هملا نم يتلا رداصملا نم ةعومجمب ءزج لك يهتنيو مهتامولعم ءارثلإ اهيلع نيفظوملا علاطا م .
              ةمظنلأا <br><br><br>يف تادجتسملا قفو اهثيدحت هللا ءاش نإ متيس يتلاو تامولعملا نم كنب وه ليلدلا
              نيلمؤم ،اهطامنأو اهعاونأو ةلئسلأا ىلع كلذ سكع متيس يلاتلابو ةيموكحلا تاهجلا ىدل تايسايسلاو
              موكح ةهج لكل تامولعملا ىلع نيفظوملا علاطا مييقتلا للاخ نم فظوم لك ةفرعم ىدم سايقو ةي
              ةرفوتملا تامولعملل يتاذلا .
              <br>
              <br>
              لع صرحلاو بوؤد لمعو ليلدلا ميمصتو ةعجارمو ءانب يف كراش يذلا لمعلا قيرف دوهج نيركاش
              ةيعوضوملاو ةقدلا يرحت

            </p>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h s-bg-img-local my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <!-- <div class="b-bottom"></div> -->
        </div>
        <div>
          <h4 class="head-purply my-5"> لا تايوتحم :</h4>
          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>

          <div class="d-flex align-items-center">
            <div>
              <div class="dot-purply"></div>
            </div>
            <div class="txt-width">
              <p class="txt-purply">و ناكسلإاو ةيورقلاو ة</p>
            </div>
            <div class="dots-purply"></div>
            <p class="txt-purply">108</p>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="container max-w-h s-bg-img-copy my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        </div>
        <h4 class="head-purply my-5"> لا تايوتحم :</h4>
      </div>
      <div class="section-padding">
        <!-- Stats Section -->
        <div class="d-flex align-items-center">
          <div class="bg-head-box-1">الثالثة خدمات </div>
          <div class="stats">
            <div class="pos-rel-pdf">
              <div class="pos-abs-circle-triangle-1"></div>
              <div class="stat-box-1">
                <div class="icon-1">
                  <div class="pos-abs-services"><i class="fa-solid fa-building"></i></div>
                </div>
                <div class="number-1">27</div>
                <div class="desc-1">إجمالي عدد نماذج الاختبارات</div>
              </div>
            </div>
            <div class="pos-rel-pdf">
              <div class="pos-abs-circle-triangle-2"></div>
              <div class="stat-box-2">
                <div class="icon-2">
                  <div class="pos-abs-services"><i class="fa-solid fa-lightbulb"></i></div>
                </div>
                <div class="number-2">489</div>
                <div class="desc-2">إجمالي عدد الأسئلة مع إجابتها</div>
              </div>
            </div>
            <div class="pos-rel-pdf">
              <div class="pos-abs-circle-triangle-3"></div>
              <div class="stat-box-3">
                <div class="icon-3">
                  <div class="pos-abs-services"><i class="fa-solid fa-sliders"></i></div>
                </div>
                <div class="number-3">9</div>
                <div class="desc-3">جهات وبرامج حكومية</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Stats Section -->


        <!-- Stats Section -->
        <div class="d-flex align-items-center">
          <div class="bg-head-box-2">الثالثة خدمات </div>
          <div class="box-flex">
            <div class="pos-rel-pdf">
              <div class="rate-box-rating">1</div>
              <div class="rate-box-rating-num">1</div>
              <div class="rate-box">
                لثالثة خدمات
              </div>
            </div>
            <div class="pos-rel-pdf">
              <div class="rate-box-rating">2</div>
              <div class="rate-box-rating-num">2</div>
              <div class="rate-box">
                لثالثة خدمات
              </div>
            </div>
            <div class="pos-rel-pdf">
              <div class="rate-box-rating">3</div>
              <div class="rate-box-rating-num">3</div>
              <div class="rate-box">
                لثالثة خدمات
              </div>
            </div>
            <div class="pos-rel-pdf">
              <div class="rate-box-rating">4</div>
              <div class="rate-box-rating-num">4</div>
              <div class="rate-box">
                لثالثة خدمات
              </div>
            </div>
          </div>
        </div>
        <!-- Stats Section -->

        <!-- Stats Section -->
        <div class="d-flex align-items-center">
          <div class="bg-head-box-3">الثالثة خدمات </div>

          <div class="d-flex">
            <div class="pos-rel-pdf">
              <div class="pos-text-adj">
                <div class="d-flex align-items-center">
                  <h4 class="h4-ui"> نص، لتكوّن كتيّب بمثابة دليل أو مرجع شكلي
                  </h4>
                  <i class="fa-solid-icone fa-solid fa-question"></i>
                </div>
              </div>
              <div class="pos-text-adj-2">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-baseline">
                    <h5 class="h5-ui">1</h5>
                    <div class="underline"></div>
                  </div>
                  <p class="under-text">هي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجيالفقرات
                    في الصفحة التي </p>
                </div>
              </div>
            </div>

            <div class="px-130 d-flex pos-rel-pdf">

              <div class="pos-rel-pdf">
                <div class="c-box-border-1">
                  <i class="pos-abs-service-arrow-1 fa-solid fa-caret-up"></i>
                  <div class="c-box-1">
                    <i class="fa-solid fa-book-open"></i>
                  </div>
                </div>
              </div>

              <div class="pos-rel-pdf">
                <div class="c-box-border-2">
                  <i class="pos-abs-service-arrow-2 fa-solid fa-caret-up"></i>
                  <div class="c-box-2">
                    <i class="fa-brands fa-searchengin"></i>
                  </div>
                </div>
              </div>

              <div class="pos-rel-pdf">
                <div class="c-box-border-3">
                  <div class="c-box-3">
                    <i class="fa-solid fa-desktop"></i>
                  </div>
                </div>
              </div>

            </div>

            <div class="pos-rel-pdf">
              <div class="pos-text-adj-3">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-baseline">
                    <h5 class="h5-ui">1</h5>
                    <div class="underline"></div>
                  </div>
                  <p class="under-text">هي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجيالفقرات
                    في الصفحة التي </p>
                </div>
              </div>
              <div class="pos-text-adj-4">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-baseline">
                    <h5 class="h5-ui">1</h5>
                    <div class="underline"></div>
                  </div>
                  <p class="under-text">هي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجيالفقرات
                    في الصفحة التي </p>
                </div>
              </div>
            </div>

          </div>

        </div>
        <!-- Stats Section -->



      </div>
    </div>
  </div>

  <div class="container p-0 max-w-h s-bg-img-2 my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="w-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        </div>
        <div class="d-flex justify-content-start">
          <div class="s-flex-2">
            <img class="filtered-logo" src="../../../../assets/nelcLogo2020.png" alt="loading">
            <div class="filtered-txt">
              <h1>2</h1>
              <h1> الأفكار المغلوط</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="my-5 pos-rel-pdf">
        <div class="c-f-img-4">
          <div class="s-box-sticky">
            <div class="d-flex flex-column">
              <h1 class="s-box-sticky-num">78</h1>
              <p class="s-box-sticky-txt">سؤال</p>
            </div>
          </div>
        </div>
        <div class="c-f-img-3">
          <img class="c-f-img-2-pic" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h s-bg-img-local my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <!-- <div class="b-bottom"></div> -->
        </div>
        <div>
          <h6 class="head-one my-5 text-center"> ةراجتلا ةرازو </h6>
          <h6 class="head-two my-3">ةمدقم</h6>
          <p class="pdf-text">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم نشأت
            بالفعل، وسأعرض لك التفاصيل لتكتشف حقيقة وأساس تلك السعادة البشرية، فلا أحد يرفض أو يكره أو يتجنب الشعور
            بالسعادة، ولكن بفضل هؤلاء الأشخاص الذين لا يدركون بأن السعادة لا بد أن نستشعرها بصورة أكثر عقلانية ومنطقية
            فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه
            <br>
            <br>لا يوجد من يرغب في الحب ونيل المنال ويتلذذ بالآلام، الألم هو
            الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.
          </p>
          <h6 class="head-three mt-5"> لا تايوتحم</h6>

          <div class="d-flex align-items-baseline">
            <div>
              <div class="s-dot"></div>
            </div>
            <p class="pdf-text"> قوقحلا مارتح</p>
          </div>

          <div class="d-flex align-items-baseline">
            <div>
              <div class="s-dot"></div>
            </div>
            <p class="pdf-text"> قوقحلا مارتحقوقحلا مارتحقوقحلا مارتح</p>
          </div>

          <div class="d-flex align-items-baseline">
            <div>
              <div class="s-dot"></div>
            </div>
            <p class="pdf-text"> قوقحلا مارتحقوقحلا مارتح</p>
          </div>

          <div class="d-flex align-items-baseline">
            <div>
              <div class="s-dot"></div>
            </div>
            <p class="pdf-text"> مارتح</p>
          </div>

          <h6 class="head-three d-flex flex-column my-5">
            <div class="d-flex">
              <div class="head-three">3-&nbsp;&nbsp;&nbsp;</div>
              طقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في
            </div>
            <p class="pdf-text m-custom">ل الحصول على ميزة أو فائدة؟ ولكن من لديه الحق أن ينتقد شخص ما أراد أن يشعر
              بالسعادة التي لا تشوبها عواقب أليمة أو آخر أراد أن يتجنب الألم الذي ربما تنجم عنه بعض المتعة ؟
              علي الجانب الآخر نشجب</p>
          </h6>

          <h6 class="head-three d-flex flex-column my-5">
            <div class="d-flex">
              <div class="head-three">3-&nbsp;&nbsp;&nbsp;</div>
              طقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في
            </div>
            <p class="pdf-text m-custom">ل الحصول على ميزة أو فائدة؟ ولكن من لديه الحق أن ينتقد شخص ما أراد أن يشعر
              بالسعادة التي لا تشوبها عواقب أليمة أو آخر أراد أن يتجنب الألم الذي ربما تنجم عنه بعض المتعة ؟
              علي الجانب الآخر نشجب</p>
            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-dot"></div>
              </div>
              <p class="pdf-text"> قوقحلا مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-dot"></div>
              </div>
              <p class="pdf-text"> قوقحلا مارتحقوقحلا مارتحقوقحلا مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-dot"></div>
              </div>
              <p class="pdf-text"> قوقحلا مارتحقوقحلا مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-dot"></div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>
          </h6>


        </div>


      </div>
    </div>
  </div>

  <div class="container max-w-h s-bg-img-semi my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <!-- <div class="b-bottom"></div> -->
        </div>
        <div>
          <h6 class="head-three d-flex flex-column my-5">
            <div class="d-flex">
              <div class="head-three mb-4">3-&nbsp;&nbsp;&nbsp;</div>
              طقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-no-dot-text">01-</div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>

            <div class="d-flex align-items-baseline activated-service">
              <div>
                <div class="col-whit-margin">01-</div>
              </div>
              <p class="col-whit"> مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-no-dot-text">01-</div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>
          </h6>

          <h6 class="head-three d-flex flex-column my-5">
            <div class="d-flex">
              <div class="head-three mb-4">3-&nbsp;&nbsp;&nbsp;</div>
              طقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في
            </div>

            <div class="d-flex align-items-baseline activated-service">
              <div>
                <div class="col-whit-margin">01-</div>
              </div>
              <p class="col-whit"> مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-no-dot-text">01-</div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-no-dot-text">01-</div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>
          </h6>


          <h6 class="head-three d-flex flex-column my-5">
            <div class="d-flex">
              <div class="head-three mb-4">3-&nbsp;&nbsp;&nbsp;</div>
              طقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-no-dot-text">01-</div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>

            <div class="d-flex align-items-baseline">
              <div>
                <div class="s-no-dot-text">01-</div>
              </div>
              <p class="pdf-text"> مارتح</p>
            </div>

            <div class="d-flex align-items-baseline activated-service">
              <div>
                <div class="col-whit-margin">01-</div>
              </div>
              <p class="col-whit"> مارتح</p>
            </div>
          </h6>

        </div>


      </div>
    </div>
  </div>


  <div class="container max-w-h s-bg-img-lcd my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <!-- <div class="b-bottom"></div> -->
        </div>
        <div>


        </div>


      </div>
    </div>
  </div>

</div>
<!-- faisal pdf services work end -->





<!-- pdf 3rd start -->
<div class="container-fluid">

  <div class="container p-0 max-w-h s-bg-img-1 my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex flex-column gap-4">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <img class="pdf-page-logo-left-mr" src="../../../../assets/nelcLogo2020.png" alt="loading">
        </div>
        <div class="d-flex justify-content-center">
          <div class="s-flex">
            <h1 class="s-main">لكن لا بدالمغلوط</h1>

          </div>
        </div>
      </div>
      <div class="s-footer pos-rel-pdf">
        <div class="c-f-img-1">
          <img class="c-f-img-1-pic" src="../../../../assets/icones-2025/Vector.png" alt="loading">
        </div>
        <div class="c-f-img-2">
          <img class="c-f-img-2-pic" src="../../../../assets/icones-2025/Group-2.png" alt="loading">
        </div>
        <div class="s-footer-flex">
          <p class="s-footer-txt-1">سعاده فيما نتحم</p>
          <p class="s-footer-txt-2">سعادة، ولكن بفضل هؤلاء الأشخاص الذين ل</p>
        </div>
      </div>

    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-2 bg-white d-flex justify-content-center align-items-center">
      <img class="vector" src="../../../../assets/picture-removebg-preview.png" alt="loading">
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-2">
      <div class="d-flex flex-column p-adjustment">
        <div class="d-flex">
          <div class="d-flex align-items-center m-left">
            <img class="less" src="../../../../assets/pngegg.png" alt="loading">
            <div class="circle-2"></div>
            <div class="circle-2"></div>
            <div class="circle-2"></div>
          </div>
          <h6 class="pdf-heading">حقوق الملكية الفكرية ©</h6>
        </div>
        <p class="pdf-text">حقــوق الملكيــة الفكريــة محفوظــة للمركــز الســعودي لألعمــال االقتصاديــة، ويحظــر
          االعتـداء عليهـا بـأي شـكل مـن األشـكال المخالفـة لنظـام حمايـة حقـوق المؤلـف وحمايـة
          الملكيـة الفكريـة.</p>
      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center">
      <img class="vector brightness" src="../../../../assets/picture-removebg-preview.png" alt="loading">
    </div>
  </div>

  <div class="container max-w-h banner my-2 p-0">
    <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center pos-rel-pdf">
      <h1 class="clr-white text-centyer"> ماعلا ميلعتلا (9.1)</h1>
      <img class="vector-2" src="../../../../assets/Vector.png" alt="loading">
    </div>
  </div>

  <div class="container max-w-h s-bg-img-local-2 my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
          <div class="b-bottom"></div>
          <img class="pdf-page-logo-left" src="../../../../assets/nelcLogo2020.png" alt="loading">
        </div>
        <h6 class="pdf-heading my-5">تعريف بالمركز السعودي لألعمال االقتصادية </h6>
        <p class="pdf-text mb-3rem">مركـز يعنـى بتيسـير إجـراءات بـدء األعمـال االقتصاديـة ومزاولتهـا وإنهائهـا وتقديـم
          جميـع الخدمـات واألعمـال
          ذات الصلـة بهـا وفقً ـا ألفضـل الممارسـات الدوليـة.
          تـم تأسـيس المركـز بموجـب قـرار مجلـس الـوزراء رقـم )456(، الصـادر بتاريـخ 11 شـعبان 1440هــ، الـذي نـص
          ً علـى تأسـيس المركـز السـعودي لألعمـال االقتصاديـة واعتمـاد تنظيمـه، وبموجبـه يرتبـط تنظيميـا بمجلـس
          الشـؤون االقتصاديـة والتنميـة.</p>
        <h6 class="pdf-heading-sky">الـــــــــــرؤية:</h6>
        <p class="pdf-text mb-3rem">أن تصبـح المملكـة العربيـة السـعودية إحـدى الـدول العشـر الرائـدة فـي العالـم مـن
          خـل جـودة وسالسـة
          وكفــاءة الخدمــات الحكوميــة الموجهــة لقطــاع األعمــال.</p>
        <h6 class="pdf-heading-sky">الرسالة:</h6>
        <p class="pdf-text">خلـق بيئـة أعمـال جاذبـة وتقديـم نمـوذج خدمـات يعـزز القـدرة التنافسـية واالسـتثمار والنمـو
          فـي المملكـة
          العربيـة السـعودية.</p>

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
          <div class="b-bottom"></div>
          <img class="pdf-page-logo-left" src="../../../../assets/nelcLogo2020.png" alt="loading">
        </div>
        <h6 class="pdf-heading my-5">الفهرس</h6>
        <!-- parent start -->
        <div class="d-flex">
          <div class="w-80rem-active">الوحدة الثالثة خدمات وزارة االستثمار</div>
          <div class="w-20rem-active">4</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">شكر وترحيب </div>
          <div class="w-20rem">0</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">جدول الرموز </div>
          <div class="w-20rem">6</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المدرب</div>
          <div class="w-20rem">77</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المشارك</div>
          <div class="w-20rem">99</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">المقدمة </div>
          <div class="w-20rem">1</div>
        </div>
        <!-- parent end -->
        <!-- child start -->
        <div class="d-flex">
          <div class="w-80rem-child">دليـل البرنامج</div>
          <div class="w-20rem">57</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
          <div class="w-20rem">2</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">الخطة الزمنية</div>
          <div class="w-20rem">56</div>
        </div>
        <!-- child child end -->
        <!-- parent start -->
        <div class="d-flex">
          <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
          <div class="w-20rem">4</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">شكر وترحيب </div>
          <div class="w-20rem">0</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">جدول الرموز </div>
          <div class="w-20rem">6</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المدرب</div>
          <div class="w-20rem">77</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المشارك</div>
          <div class="w-20rem">99</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">المقدمة </div>
          <div class="w-20rem">1</div>
        </div>
        <!-- parent end -->
        <!-- child start -->
        <div class="d-flex">
          <div class="w-80rem-child">دليـل البرنامج</div>
          <div class="w-20rem">57</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
          <div class="w-20rem">2</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">الخطة الزمنية</div>
          <div class="w-20rem">56</div>
        </div>
        <!-- child child end -->

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
          <div class="b-bottom"></div>
          <img class="pdf-page-logo-left" src="../../../../assets/nelcLogo2020.png" alt="loading">
        </div>
        <h6 class="pdf-heading my-5">إرشادات المدرب</h6>
        <div class="d-flex mb-3">
          <div class="d-flex align-items-center">
            <img class="services-icon" src="../../../../assets/icons/SBC/379.svg" alt="loading">
          </div>
          <div class="">
            <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
            <h6 class="pdf-heading-sky-mini-2"> ةأشنملا قاطن جراخ ةيريوطت ةرود دقع )9.3.27(: </h6>
          </div>
        </div>
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <img class="services-icon-2" src="../../../../assets/icons/SBC/bank.svg" alt="loading">
          </div>
          <div class="">
            <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
          </div>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي توضيـح
            مـا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا ألفضـل
            سـيناريو
            وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
            تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي البيئـة
            التدريبيـة التـي
            سـتنفذ بهـا التدريب.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة غيـر
            مناسـبة مـع
            المشـاركين والبيئـة.</p>
        </div>
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <img class="services-icon-2" src="../../../../assets/icons/SBC/hand-certificacte.svg" alt="loading">
          </div>
          <div class="">
            <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
          </div>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية بعدد المشاركين قبل الجلسة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">أعد مراجعة اليوم التدريبي األول، وأعد نفسك جيدا.</p>
        </div>
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <img class="services-icon-2" src="../../../../assets/icons/SBC/glass-paper-pen.svg" alt="loading">
          </div>
          <div class="">
            <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
          </div>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">جهز نفسك قبل بدء الدورة بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">احضر باكرا وحاول التحقق من القاعة والتعرف على مخارج الطوارئ وموقع الصالة والضيافة. </p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text">راجع مع منسق التدريب المعينات التدريبية وتحقق من توافرها كاملة. </p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-dot-blue"></div>
          </div>
          <p class="pdf-text"> استقبل المشاركين ورحب بهم. </p>
        </div>
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <img class="services-icon-2" src="../../../../assets/icons/SBC/flower disk.svg" alt="loading">
          </div>
          <div class="">
            <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
          </div>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">1.</div>
          </div>
          <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي توضيـح
            مـا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">2.</div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا ألفضـل
            سـيناريو
            وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
            تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">3.</div>
          </div>
          <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">4.</div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">5.</div>
          </div>
          <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي البيئـة
            التدريبيـة التـي
            سـتنفذ بهـا التدريب.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">6.</div>
          </div>
          <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-3">
          <div>
            <div class="list-num-blue">7.</div>
          </div>
          <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة غيـر
            مناسـبة مـع
            المشـاركين والبيئـة.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h s-bg-img-local-2 my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
          <div class="b-bottom"></div>
          <img class="pdf-page-logo-left" src="../../../../assets/nelcLogo2020.png" alt="loading">
        </div>
        <div class="my-5">
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <img class="services-icon-2" src="../../../../assets/icons/SBC/bank.svg" alt="loading">
            </div>
            <div class="">
              <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
            </div>
          </div>
          <div class="d-flex align-items-baseline mrr-3">
            <div>
              <div class="list-dot-blue"></div>
            </div>
            <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي
              توضيـح
              مـا</p>
          </div>
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <img class="services-icon-2" src="../../../../assets/icons/SBC/hand-certificacte.svg" alt="loading">
            </div>
            <div class="">
              <h6 class="pdf-heading-sky-2">قبل الجلسة التدريبية بيومين على األقل:</h6>
            </div>
          </div>
          <div class="d-flex align-items-baseline mrr-3">
            <div class="s-qr-box">
              <div class="s-qr-text">07</div>
              <img class="s-qr"
                src="data:image/png;base64,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"
                alt="loading">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h s-bg-img-local-2 my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex flex-column-reverse gap-2 align-items-baseline">
          <div class="b-bottom"></div>
          <img class="pdf-page-logo-left" src="../../../../assets/nelcLogo2020.png" alt="loading">
        </div>

        <div class="d-flex flex-column my-5 py-5">
          <div class="s-g-txt-border">
          <div class="s-g-text">
            ةعئاشلا ةلئسلأا ىلع عاطلاا مكنكمي
            بيردتلل ةماعلا ةسسؤملا تامدخب ةصاخلا :يلاتلا طبارلا لاخ نم ينهملاو ينقتلا
          </div>
        </div>
          <div class="s-g-qr">
            <img class="s-qr-2"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAeFBMVEX///8AAAB4eHgnJye7u7vo6OiioqJwcHDy8vLBwcFnZ2evr6/i4uKHh4dVVVWcnJy1tbU1NTXS0tKVlZWpqamOjo7Y2Nh/f3/Hx8dMTEzx8fH4+Phra2sbGxtHR0fg4OA8PDwREREwMDBcXFwiIiIYGBgxMTFBQUH/lneRAAAKh0lEQVR4nO2df0OyMBDH0xBFU0nwJ6SWVu//HT7ujie/eAyHYFrd9y8a27GP6ca22+3hQaVSqVQqlUqlUqlUKpVKpVKpVKWKu21HzbEYpaQJXUfmursRphdg2of0JD2mp5w0d61EN65M2G256gWLcdKKrpd0PRGmB1A4hfQVWuWkF+dadCsTtp1tP0rCHl2PHAixYj1J+Ohci7YSKmE1Qm5pXH6HfUhPbkE4DLwSxTbC4dQoNHlCbnU8kzScAGGfTHPKigpEbFUSxmWVCIa1CIPSPB0bIasD6XNKGQDhEO4+oSFJiIakglqEXmmeM4RPkD50IHxGE3ztQugpoUVKaHQhYSwIc4ZuQTgZ+yfybISx0WBfSjjzKRfaiyHFRuidVmI8aYxw3DrVzkbIei4lZAVgbkkp1v6QCXeiFuPGCH1hu98s4YhSrO80TNgXtfCVUAkvJ3y0EIalhAXjw7siHIQHZf8kPzpouhKEcy/8UmzyRG0gTKbRl6Z3SIgfvdRQmOD+cAaEBfoFhBMlVEIlbJCwPT8o95zJ4qBgJQiXQ5N1bO4uQio2pevFnRNKren2RBByxbg/TMHQ/scR4lwbEo6BkOfacuNDJVTCbyTE+dJyws6tCb1d/0SRJJzMvpRNAg9Nzp1HSZG5Tj8F4W5j7gYuhNFpJXZeY4Q2FfSHLHznTimFJ159QYg6Q2jTTQh7kKkLhGMlPJUSGimhTUwYd8o0kYRLo+2GbicOhHsqsEZCto2Ek9JaxLUIXVQwtuAZ4Y0DIVcs1x+iobtaIcWK4VxbOWHBO40SKmHzhHtZsY+LCD+kof0VCecvj27ab7FiidHDen+4kSP0KD2i6+jB/BG8HvK8tOl60zKG1nSdIOF271iLl3kxRpPCDzSBdJtzFc6Xrum6YO3proTVkz2+jRBnogrWLe5KSqiEP4sQWxo5+YCEuDJTsLp2feH0ylTc7cjKYCXRd3YK6Ty9soCUkTQhzfHcCH8lcKm1nrBikYWwgrcJS46erIT4TjOjFHYfw6VWJVTCv024wspUJfTulRCbwKWNDQltYwtWwfqhO2EMd6uPLZRQCZXwXgixCZSEWxdCfi/lqeUIDLFwBFxAiOaYsN0wYbLq/VcSPj4/P78Nk6+U3mZ/SPlYlxNS/lVyNJddL0zhtzabsxHyk9dASCaSyNTl0TeFk0EtQlRIlnA+JOdgYCO0CWeickJC1hIIWfxlqLdCKmUjLFi3UEIjJQR9F6H8RedGwFUJuVHuyxs2QhxQMyF3O/zJ41ZNN0XL0Wi0REes3pMRruUlG5OyWR9yjjJPes7zVkoYkOmoc2quR4bYR6W1G31p904p62PKckCFV5Z6ucllhTTjxP8bJ0k/b5TcM5MRyq+BTU2MLZTwKCUUuivC8h2WmaoSyp1drFXLWc0Rjrrn1Z5NDuJX6BanvJcSdkz+SZgecqY4znig9ImNamCeM0uBMOgbE5fOnbqvkGYRB+QNlx6/oBuzPcc2epIz1U0TXuedRgmVsEnC15sR+o0RzhdBECzklomtSQ+CIYmucY6jgDCYHzLOA0G4mg+PYqOkBcc2GZhrbyUInyhTTKWqt6hIyKVxkpqV29zKxcoJcZ5Gepu00BBLeu7JOW8PDF1KyNFtwvqE5f40tQjreQwp4c8kRAcD30L4iVTuhPg7xF1BBYSvFkIcEVxKuBh8KeZ2ehMPTjUmcSYuBjdjnAUNIpOTLbC5J/ojJgu5Zto3KdmscXh8TNQBwq7JFNWLOOAi/ujfXbJi9BbUTHwxCv6TOCM8hzz1Ig646MyeGZTcrc6yjiQwE861IWHTc21SSgj60YROv0MZcYDlROjyO6z+TiNla0uzwIBwN+bVpYCuO0DYDo9tKasTibaUFYommx4Q8nQqtqUzMuEyo3RO1v6QhTdkVEG5EInK9YdScndeEzwuhNY1YBmRTnqboHLvNC6EzXmbKOFvJyxYfr+MsPLvsAnCyXGkHfAr9AQH4qQpj+u5AN2duhC2YRTP4gmXlylZ5Ux0PX2laxrjB9HxwXM2+gQmZHjGc5JjCyn+6F8xyYXQpjN7ZrCTYeEO7CbG+DZCp+ieVyGs522ihH+JsCBScgKEs/smpLWnNKbVJW6zV7Q+xF4Dq/5x7Slry2jtKV3QahS/MPOSETdcS1iyYv6PtrnuIyEZ7fOCFu9d4xRu0Z/oYfxaSGtPmaF6EVpxbjkLhYBZ8UNn2TbVYTe2gIoVRI3AYhjAgOslA781ERcDPfcKwv9i4WcLoayYNfIHFrvmbKIS/l5CXLotIHy7iPDtewnRJ4oJh8YPqcOOFDvySWKxT9QSUjp9cmWSQfHH4MqUi09DJvpsgp+/PHpArZmQfai4UfbBUBPzNDICT06cCVO4P5QhVVly7YlV8GVANR2h1Z3QGhdjZCkg1y1YvXLCpmMMKeFfIizw8/4RhOilz4tixrf+v7g7eH0mX31yt09ezB9bfnSHUpDwkYrx21xELvYhEtLD/jvk9k6UvbS134yJl6O5zFc/20NQmTC1fPSsDaVkM1H40Vv+bS3sdlBdMGcV9oc8SOF+umlvE7kR5MwaMAr3zEhCp7k21jX9aZRQCZXwuwlRMRDKIGQ5cYEtVEw6V7EWQPhQ/vFINU0oR09nCGUUJUlo7fGVUAmVsEhjsOTU0vDLI0+q4guzbGnwhbnybgRsAb9BWIHEkkf2FqyCpVZZGN+U5T7gJnwxzghr3LPksRFa93Kj5AppEzudK0gJjZQQDMnCd0Voa2ls0yHWiAMo6TFUj7By3MTkKI6bWKB3qNIwV8JCSHETC3wxqHLvPpkILySsHPsS9eFQzDqxgoQ8sXPNmOwusp731ADh9aPOK6ES1iVsORNWjzhQOZ43a03xuV/pBoThXrE5n/7wgXC2NeG8+R/Q21JhJMTY3kjIhuJPUzjiJ1xIePVTOivEvrT1+PVmopRQCX85oVxQCYFwXpUQR8B4KG0ThE7nzEjCXWoOg9kA4dqk9H06eaZTTpiePjLNzuimwquGCSucFSRynvGCthLahBFzlFAJlfD2hIPbEXqLLxWcf3iGkI5NzPa0BXS9FYQeHZs4uh2hnKepQCgNLQUhxuS8CaGca2uYMFJCJaxLKIej8hxSSVjgEOBCeOnaU2VCPlSbjtweYEsTmuQxVnI3NgdvB0D4MT4WpvzR2J1wRIWr7ypt7Dxg6T7GwrFFSxpyJ2RdurOrAUKXEzxYuT0zVQlveKazEt4FoVwU29UnlL9DK+GnA2G93+Fk7J/IsxHGRr480aptSsU81dKPzR9c1Q6ZnkpCyjNmQwN4csxPEHKK8GgltMnpLNkufPT8dZebbq3nH0o1d/rD1U/pRFnPzpNSQnf9FcLy36+VULY0bCgqJTzTKLOaJhwGXolirNhwelDWig+OeYIREC4okw8meI5jReljJKQHZyALMLcThB0wVJ3QRWfmaVriyzCAdGvEcvwyfLZOhYS5jRv3R3gm9qV8p5GE37wGrIR3RGh7nZQqiDjgTngmUjITrh0Iq/8O427bUblTXC15utjULcB0QdiU9Hg3ZcJpqbmJMde1xX1QqVQqlUqlUqlUKpVKpVKpVCpVpn9lFgUCI6E3/AAAAABJRU5ErkJggg=="
              alt="loading">
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner">
      <div class="footer-pdf">

        <div class="d-flex mx-4">
          <img class="footer-vector brightness" src="../../../../assets/picture-removebg-preview.png" alt="loading">
        </div>

        <div class="d-flex align-items-end flex-column mx-4">
          <div class="d-flex mb-2">
            <div class="d-flex align-items-center">
              <span class="footer-white">199080</span>
              <i class="mx-2 footer-white fa-brands fa-whatsapp"></i>
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <span class="footer-white">+99611228 2881</span>
              <i class="mx-2 footer-white fa-solid fa-headphones"></i>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-end flex-column mx-4">
          <div class="d-flex mb-2">
            <div class="d-flex align-items-center mll-2">
              <span class="footer-white">BUSINESS.SA</span>
              <i class="mx-2 footer-white fa-solid fa-globe"></i>
            </div>
            <div class="d-flex align-items-center">
              <span class="footer-white">BCGOV_SA</span>
              <i class="mx-2 footer-white pi pi-twitter"></i>
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <span class="footer-white">SAUDI BUSINESS CENTER</span>
              <i class="mx-1 footer-white fa-brands fa-instagram"></i>
              <i class="mx-1 footer-white fa-brands fa-linkedin"></i>
              <i class="mx-1 footer-white fa-brands fa-youtube"></i>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>


</div>
<!-- pdf 3rd end -->






<!-- faisal PDF DESIGN WORK START -->
<div class="container-fluid">
  <div class="container max-w-h banner my-2">
    <div class="bg-banner">
      <div class="d-flex flex-column">
        <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="p-3rem">
          <div class="bar pos-rel-pdf">
            <div class="d-flex pos-abs-pdf">
              <div class="circle-dot"></div>
              <div class="circle-dot"></div>
              <div class="circle-dot"></div>
            </div>
            خدمات وزارة االسـتثمار
          </div>
          <div class="d-flex justify-content-end">
            <div class="blue-box">جميع الحقوق محفوظة</div>
            <div class="sky-box">جميع الحقوق محفوظة</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-2">
      <div class="d-flex flex-column p-adjustment">
        <div class="d-flex">
          <div class="d-flex align-items-center m-left">
            <img class="less" src="../../../../assets/pngegg.png" alt="loading">
            <div class="circle-2"></div>
            <div class="circle-2"></div>
            <div class="circle-2"></div>
          </div>
          <h6 class="pdf-heading">حقوق الملكية الفكرية ©</h6>
        </div>
        <p class="pdf-text">حقــوق الملكيــة الفكريــة محفوظــة للمركــز الســعودي لألعمــال االقتصاديــة، ويحظــر
          االعتـداء عليهـا بـأي شـكل مـن األشـكال المخالفـة لنظـام حمايـة حقـوق المؤلـف وحمايـة
          الملكيـة الفكريـة.</p>
      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center">
      <img class="vector brightness" src="../../../../assets/picture-removebg-preview.png" alt="loading">
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <h6 class="pdf-heading my-5">تعريف بالمركز السعودي لألعمال االقتصادية </h6>
        <p class="pdf-text mb-3rem">مركـز يعنـى بتيسـير إجـراءات بـدء األعمـال االقتصاديـة ومزاولتهـا وإنهائهـا
          وتقديـم
          جميـع الخدمـات واألعمـال
          ذات الصلـة بهـا وفقً ـا ألفضـل الممارسـات الدوليـة.
          تـم تأسـيس المركـز بموجـب قـرار مجلـس الـوزراء رقـم )456(، الصـادر بتاريـخ 11 شـعبان 1440هــ، الـذي نـص
          ً علـى تأسـيس المركـز السـعودي لألعمـال االقتصاديـة واعتمـاد تنظيمـه، وبموجبـه يرتبـط تنظيميـا بمجلـس
          الشـؤون االقتصاديـة والتنميـة.</p>
        <h6 class="pdf-heading-sky">الـــــــــــرؤية:</h6>
        <p class="pdf-text mb-3rem">أن تصبـح المملكـة العربيـة السـعودية إحـدى الـدول العشـر الرائـدة فـي العالـم مـن
          خـل جـودة وسالسـة
          وكفــاءة الخدمــات الحكوميــة الموجهــة لقطــاع األعمــال.</p>
        <h6 class="pdf-heading-sky">الرسالة:</h6>
        <p class="pdf-text">خلـق بيئـة أعمـال جاذبـة وتقديـم نمـوذج خدمـات يعـزز القـدرة التنافسـية واالسـتثمار
          والنمـو
          فـي المملكـة
          العربيـة السـعودية.</p>
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading my-5">شكر وترحيب</h6>
        </div>
        <p class="pdf-text mb-3rem">يتقـدم المركـز السـعودي لألعمـال االقتصاديـة بالشـكر والترحيـب بالمشـاركين فـي
          البرنامـج التدريبـي، كمـا
          َّ يتمنـى لهـم االسـتفادة الفاعلـة منـه، آمليـن أن ينعكـس أثـر هـذا التدريـب علـى جـودة الخدمـات المقدمـة
          مـن
          َقِ ب ً ـل المركـز السـعودي لألعمـال االقتصاديـة، وأن يشـكل دور ً ا حقيقيـا فـي تطويـر رؤيتـه، ورسـالته،
          وأهدافـه،
          وأن يقـدم خدمـة شـاملة للمسـتثمرين تسـاهم فـي تحقيـق رؤيـة المملكـة 2030م بعـون اللـه تعالـى.</p>
        <div class="d-flex justify-content-center my-5">
          <p class="pdf-black">والله ولي التوفيق</p>
        </div>
        <div class="d-flex justify-content-end">
          <p class="pdf-black">فريق العمل</p>
        </div>
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <h6 class="pdf-heading my-5">الفهرس</h6>
        <!-- parent start -->
        <div class="d-flex">
          <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
          <div class="w-20rem">4</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">شكر وترحيب </div>
          <div class="w-20rem">0</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">جدول الرموز </div>
          <div class="w-20rem">6</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المدرب</div>
          <div class="w-20rem">77</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المشارك</div>
          <div class="w-20rem">99</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">المقدمة </div>
          <div class="w-20rem">1</div>
        </div>
        <!-- parent end -->
        <!-- child start -->
        <div class="d-flex">
          <div class="w-80rem-child">دليـل البرنامج</div>
          <div class="w-20rem">57</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
          <div class="w-20rem">2</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">الخطة الزمنية</div>
          <div class="w-20rem">56</div>
        </div>
        <!-- child child end -->
        <!-- parent start -->
        <div class="d-flex">
          <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
          <div class="w-20rem">4</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">شكر وترحيب </div>
          <div class="w-20rem">0</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">جدول الرموز </div>
          <div class="w-20rem">6</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المدرب</div>
          <div class="w-20rem">77</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المشارك</div>
          <div class="w-20rem">99</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">المقدمة </div>
          <div class="w-20rem">1</div>
        </div>
        <!-- parent end -->
        <!-- child start -->
        <div class="d-flex">
          <div class="w-80rem-child">دليـل البرنامج</div>
          <div class="w-20rem">57</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
          <div class="w-20rem">2</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">الخطة الزمنية</div>
          <div class="w-20rem">56</div>
        </div>
        <!-- child child end -->

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex mbb-2rem">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <!-- parent start -->
        <div class="d-flex">
          <div class="w-80rem">الوحدة الثالثة خدمات وزارة االستثمار</div>
          <div class="w-20rem">4</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">شكر وترحيب </div>
          <div class="w-20rem">0</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">جدول الرموز </div>
          <div class="w-20rem">6</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المدرب</div>
          <div class="w-20rem">77</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">إرشادات المشارك</div>
          <div class="w-20rem">99</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem">المقدمة </div>
          <div class="w-20rem">1</div>
        </div>
        <!-- parent end -->
        <!-- child start -->
        <div class="d-flex">
          <div class="w-80rem-child">دليـل البرنامج</div>
          <div class="w-20rem">57</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">األدوات والوسائل المستخدمة </div>
          <div class="w-20rem">2</div>
        </div>
        <div class="d-flex">
          <div class="w-80rem-child">الخطة الزمنية</div>
          <div class="w-20rem">56</div>
        </div>
        <!-- child child end -->
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <h6 class="pdf-heading my-5">الفهرس</h6>

        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>

        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100 mll-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
          <div class="d-flex w-100 mrr-2">
            <div class="w-40rem">ورشة عمل.</div>
            <div class="w-10rem"><img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading my-5">إرشادات المدرب</h6>
        <h6 class="pdf-heading-sky-mini">عزيزي المدرب: </h6>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيومين على األقل:</h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي
            توضيـح
            مـا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا ألفضـل
            سـيناريو
            وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
            تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي البيئـة
            التدريبيـة التـي
            سـتنفذ بهـا التدريب.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة غيـر
            مناسـبة مـع
            المشـاركين والبيئـة.</p>
        </div>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيوم: </h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية بعدد المشاركين قبل الجلسة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">أعد مراجعة اليوم التدريبي األول، وأعد نفسك جيدا.</p>
        </div>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بساعة:</h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">جهز نفسك قبل بدء الدورة بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">احضر باكرا وحاول التحقق من القاعة والتعرف على مخارج الطوارئ وموقع الصالة والضيافة. </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">راجع مع منسق التدريب المعينات التدريبية وتحقق من توافرها كاملة. </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> استقبل المشاركين ورحب بهم. </p>
        </div>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيومين على األقل:</h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي
            توضيـح
            مـا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا ألفضـل
            سـيناريو
            وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
            تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي البيئـة
            التدريبيـة التـي
            سـتنفذ بهـا التدريب.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة غيـر
            مناسـبة مـع
            المشـاركين والبيئـة.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading my-5">إرشادات المدرب</h6>
        <h6 class="pdf-heading-sky-mini">عزيزي المدرب: </h6>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيومين على األقل:</h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي
            توضيـح
            مـا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا ألفضـل
            سـيناريو
            وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
            تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">احرص على قراءة الحقيبة التدريبية قبل التدريب بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية التي سيتم استخدامها في األنشطة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">راجـع أسـاليب تنفيـذ األنشـطة وتحقـق مـن إمكانيـة تطبيـق هـذه األسـاليب فـي البيئـة
            التدريبيـة التـي
            سـتنفذ بهـا التدريب.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> ً راجع شرائح العرض التقديمي وخطط لعملية التدريب جيدا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">ضـع خطـط وطرائـق أخـرى لتنفيـذ األنشـطة التدريبيـة إن كانـت األسـاليب التدريبيـة غيـر
            مناسـبة مـع
            المشـاركين والبيئـة.</p>
        </div>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بيوم: </h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تحقق من توافر المعينات التدريبية بعدد المشاركين قبل الجلسة التدريبية.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">أعد مراجعة اليوم التدريبي األول، وأعد نفسك جيدا.</p>
        </div>
        <h6 class="pdf-heading-sky">قبل الجلسة التدريبية بساعة:</h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">جهز نفسك قبل بدء الدورة بوقت كافٍ .</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">احضر باكرا وحاول التحقق من القاعة والتعرف على مخارج الطوارئ وموقع الصالة والضيافة. </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">راجع مع منسق التدريب المعينات التدريبية وتحقق من توافرها كاملة. </p>
        </div>
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading my-5">شكر وترحيب</h6>
        </div>
        <p class="pdf-text mb-3rem">يتقـدم المركـز السـعودي لألعمـال االقتصاديـة بالشـكر والترحيـب بالمشـاركين فـي
          البرنامـج التدريبـي، كمـا
          َّ يتمنـى لهـم االسـتفادة الفاعلـة منـه، آمليـن أن ينعكـس أثـر هـذا التدريـب علـى جـودة الخدمـات المقدمـة
          مـن
          َقِ ب ً ـل المركـز السـعودي لألعمـال االقتصاديـة، وأن يشـكل دور ً ا حقيقيـا فـي تطويـر رؤيتـه، ورسـالته،
          وأهدافـه،
          وأن يقـدم خدمـة شـاملة للمسـتثمرين تسـاهم فـي تحقيـق رؤيـة المملكـة 2030م بعـون اللـه تعالـى.</p>
        <div class="my-5 py-5">
          <h1 style="color: lightgrey;" class="my-5 py-5 text-center">
            DIAGRAM DESIGN
          </h1>
        </div>
        <p class="pdf-text mb-3rem">يتقـدم المركـز السـعودي لألعمـال االقتصاديـة بالشـكر والترحيـب بالمشـاركين فـي
          البرنامـج التدريبـي، كمـا
          َّ يتمنـى لهـم االسـتفادة الفاعلـة منـه، آمليـن أن ينعكـس أثـر هـذا التدريـب علـى جـودة الخدمـات المقدمـة
          مـن
          َقِ ب ً ـل المركـز السـعودي لألعمـال االقتصاديـة، وأن يشـكل دور ً ا حقيقيـا فـي تطويـر رؤيتـه، ورسـالته،
          وأهدافـه،
          وأن يقـدم خدمـة شـاملة للمسـتثمرين تسـاهم فـي تحقيـق رؤيـة المملكـة 2030م بعـون اللـه تعالـى.</p>
        <div class="d-flex justify-content-end">
          <p class="pdf-black">فريق العمل</p>
        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading mtt-3rem">إرشادات المدرب</h6>
        <h6 class="pdf-heading-sky-mini my-3">عزيزي المدرب: </h6>
        <!-- table start -->
        <div class="mask">
          <div>
            <table>
              <thead>
                <tr>
                  <th>م</th>
                  <th>المستلزمات </th>
                  <th>العدد</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>وحة عرض Flipchart.</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>أقالم تخطيط ملونة.</td>
                  <td>7</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>وحة عرض Flipchart.</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>أقالم تخطيط ملونة.</td>
                  <td>7</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>وحة عرض Flipchart.</td>
                  <td>4</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>أقالم تخطيط ملونة.</td>
                  <td>7</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- table end -->
        <h6 class="pdf-heading-sky-mini my-3">عزيزي المدرب: </h6>
        <!-- table start -->
        <div class="mask">
          <div>
            <table>
              <thead>
                <tr>
                  <th>اليوم
                    التدريبي
                  </th>
                  <th>النشاط</th>
                  <th>العدد</th>
                  <th>وصف األداة</th>
                  <th>الحجم</th>
                  <th>اإلجمالي</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>فئات االستثمار في المملكة</td>
                  <td>4</td>
                  <td>بطاقة</td>
                  <td>A5</td>
                  <td>مجموعة واحدة. </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>فئات االستثمار في المملكة</td>
                  <td>4</td>
                  <td>بطاقة</td>
                  <td>0 × 15 سم</td>
                  <td>مجموعة واحدة. </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>فئات االستثمار في المملكة</td>
                  <td>4</td>
                  <td>بطاقة</td>
                  <td>A5</td>
                  <td>مجموعة واحدة. </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>فئات االستثمار في المملكة</td>
                  <td>4</td>
                  <td>بطاقة</td>
                  <td>0 × 15 سم</td>
                  <td>مجموعة واحدة. </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- table end -->
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading mtt-3rem">الخطة الزمنية</h6>
        <!-- table start -->
        <div class="mask">
          <div>
            <table>
              <thead>
                <tr>
                  <th>اليوم
                    التدريبي</th>
                  <th>رقم
                    الوحدة</th>
                  <th>عنوان الوحدة
                    التدريبية
                  </th>
                  <th>الجلسةالتدريبية</th>
                  <th>موضوعات الجلسة</th>
                  <th>الزمن بالدقيقة</th>
                </tr>
              </thead>
              <tbody>
                <!-- 1st <tr> start -->
                <tr>
                  <td rowspan="11">األول</td>
                  <td rowspan="4">األولى</td>
                  <td rowspan="4">التعريفبوزارةاالستثمار</td>
                  <td rowspan="4">األولى</td>
                  <td>االفتتاح.</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>التقييم القبلي.</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td>نبذة عن وزارة االستثمار</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>صالحيات وزارة االستثمار</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td colspan="4" style="background-color: #082564; color: white;">tab 4</td>
                  <td style="background-color: #082564; color: white;">tab 6</td>
                </tr>
                <tr>
                  <td rowspan="2">األولى</td>
                  <td rowspan="2">التعريفبوزارةاالستثمار</td>
                  <td rowspan="2">الثانية</td>
                  <td>مراحل تطور االستثمار في المملكة.</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>الخدمات اإللكترونية.</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td colspan="4" style="background-color: #082564; color: white;">استراحة</td>
                  <td style="background-color: #082564; color: white;">15</td>
                </tr>
                <tr>
                  <td rowspan="3">الثانية</td>
                  <td rowspan="3">التعريفبوزارةاالستثمار</td>
                  <td rowspan="3">الثانية </td>
                  <td>مراحل تطور االستثمار في المملكة.</td>
                  <td>20</td>
                </tr>
                <tr>
                  <td>الخدمات اإللكترونية.</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td></td>
                  <td>30</td>
                </tr>
                <tr>
                  <td colspan="6" style="background-color: #082564; padding: 15px 0px;"></td>
                </tr>
                <!-- 1st <tr> end -->
                <!-- 2nd <tr> start -->
                <tr>
                  <td rowspan="11">الثاني</td>
                  <td rowspan="2">الثانية</td>
                  <td rowspan="2">التعريفبوزارةاالستثمار</td>
                  <td rowspan="3">األولى</td>
                  <td>رحلة المستثمر. </td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>تصنيف خدمات وزارة االستثمار.</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>الثالثة</td>
                  <td>التعريفبوزارةاالستثمار</td>
                  <td>أبرز خدمات إصدار التراخيص</td>
                  <td>35</td>
                </tr>
                <tr>
                  <td colspan="4" style="background-color: #082564; color: white;">استراحة</td>
                  <td style="background-color: #082564; color: white;">15</td>
                </tr>
                <tr>
                  <td rowspan="2">الثالثة</td>
                  <td rowspan="2">التعريفبوزارةاالستثمار</td>
                  <td rowspan="2">الثانية</td>
                  <td>أبرز خدمات خدمة تعديل التراخيص.</td>
                  <td>40</td>
                </tr>
                <tr>
                  <td>خدمة تجديد التراخيص.</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td colspan="4" style="background-color: #082564; color: white;">استراحة</td>
                  <td style="background-color: #082564; color: white;">15</td>
                </tr>
                <tr>
                  <td rowspan="4">الثالثة</td>
                  <td rowspan="4">التعريفبوزارةاالستثمار</td>
                  <td rowspan="4">الثالثة</td>
                  <td>أبرز خدمات وزارة االستثمار الخاصة
                    بمركز عالقات المستثمرين.</td>
                  <td>40</td>
                </tr>
                <tr>
                  <td>التقييم البعدي </td>
                  <td>15</td>
                </tr>
                <tr>
                  <td>تقييم البرنامج التدريبي</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>الختام</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td colspan="5" style="background-color: #082564; color: white;">مجموع الزمن</td>
                  <td style="background-color: #082564; color: white;">480دقيقة</td>
                </tr>


                <!-- 2nd <tr> end -->
              </tbody>
            </table>
          </div>
        </div>
        <!-- table end -->
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2 pos-rel-pdf">
    <div class="pos-abs-grey-box"></div>
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading mtt-3rem z-index-1">إرشادات المدرب</h6>
        <!-- table start -->
        <div class="mask z-index-1">
          <div>
            <table>
              <thead>
                <tr>
                  <th>م</th>
                  <th>المستلزمات </th>
                  <th>العدد</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">1</td>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                  <td style="background-color: #082564; color: white;">15</td>
                </tr>
                <tr>
                  <td rowspan="2">1</td>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                  <td style="background-color: #082564; color: white;">15</td>
                </tr>
                <tr>
                  <td rowspan="3">1</td>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td>شاشة عرض.</td>
                  <td>9</td>
                </tr>
                <tr>
                  <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                  <td style="background-color: #082564; color: white;">15</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- table end -->
      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner">
      <div class="d-flex flex-column">
        <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="bg-gradiant-ui">
          <div class="sticky-pos-rel">
            <div class="sticky-sky-bar"></div>
            <div class="sticky-blu-box">
              <h2 class="sticky-text">الوحدة األولى</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner">
      <div class="d-flex flex-column">
        <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="bg-gradiant-ui">
          <div class="d-flex justify-content-end mtt-mll-auto">
            <h2 class="sticky-text">التعريف بوزارة االستثمار</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner">
      <div class="d-flex flex-column">
        <img class="pdf-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <div class="table-border-left mtt-3rem">إرشادات المدرب</div>
        <!-- table start -->
        <div class="table-border-right">
          <div class="mask">
            <div>
              <table>
                <thead>
                  <tr>
                    <th>م</th>
                    <th>المستلزمات </th>
                    <th>العدد</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="4">1</td>
                    <td>شاشة عرض.</td>
                    <td>9</td>
                  </tr>
                  <tr>
                    <td>شاشة عرض.</td>
                    <td>9</td>
                  </tr>
                  <tr>
                    <td>شاشة عرض.</td>
                    <td>9</td>
                  </tr>
                  <tr>
                    <td>شاشة عرض.</td>
                    <td>9</td>
                  </tr>
                  <tr>
                    <td colspan="2" style="background-color: #082564; color: white;">استراحة</td>
                    <td style="background-color: #082564; color: white;">15</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- table end -->
        <div class="d-flex icon-adjustment">
          <img class="pen-icon" src="../../../../assets/icons/SBC/inkpaper.svg" alt="loading">
          <h6 class="pdf-heading">هداف الجلسة</h6>
        </div>
        <h6 class="pdf-heading-sky-mini font-500">مع نهاية هذه الجلسة بإذن الله؛ سيكون المتدرب قادرا على أن:</h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي
            توضيـح
            مـا</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة التدريبيـة وفقً ـا ألفضـل
            سـيناريو
            وبمـا يضمـن تحقيـق أهـداف النشـاط، ومـع ذلـك يمكنـك تغييـر أسـلوب تنفيـذ النشـاط بشـرط ضمـان
            تحقـق أهـداف النشـاط باألسـلوب الـذي سـتتَّ بعه.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <div class="d-flex my-4">
          <img class="pen-icon" src="../../../../assets/icons/SBC/inkpaper.svg" alt="loading">
          <h6 class="pdf-heading-bg">مالحظات</h6>
        </div>
        <div class="d-flex flex-column">
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <div class="row mtt-3rem">
          <div class="col-md-6 col-6">
            <div class="d-flex">
              <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
              <h6 class="pdf-heading-bg">مالحظات</h6>
            </div>
          </div>
          <div class="col-md-6 col-6">
            <div class="d-flex justify-content-end align-items-baseline">
              <img class="timer-stand-img" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <div class="timer-stand pos-rel-pdf">
                <div class="timer-dot"></div>
              </div>
              <h6 class="timer-text">5 دقيقة</h6>
            </div>
          </div>
        </div>
        <h6 class="pdf-heading-sky-mini font-500 my-2">مع نهاية هذه الجلسة بإذن الله؛ سيكون المتدرب قادرا على أن:</h6>
        <div class="d-flex justify-content-center align-items-center">
          <img class="qr-code"
            src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
            alt="loading">
        </div>
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading my-5">الجدول المعرفي الذاتي KWL.</h6>
        <p class="pdf-text">هــذا الجــزء خــاص بــك كمشــارك، نأمــل أن تجيــب عــن األســئلة التــي تضمنتهــا
          الحقيبــة قبــل بدايــة الــدورة
          التدريبيـة، والعـودة إليهـا فـي نهايتهـا؛ للمقارنـة بيـن مـا كنـت تتوقـع معرفتـه، وبمـا حصلـت عليـه مـن
          معرفـة. </p>
        <div class="row p-0">
          <div class="col-md-4 p-0">
            <div class="d-flex flex-column">
              <div class="balance-sheet-header">
                ماذا أعرف؟ K
              </div>
              <div class="balance-sheet-box">
                null
              </div>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex flex-column">
              <div class="balance-sheet-header">
                ماذا أريد أن أعرف؟ W
              </div>
              <div class="balance-sheet-box">
                null
              </div>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex flex-column">
              <div class="balance-sheet-header">
                ماذا تعلمت؟ L
              </div>
              <div class="balance-sheet-box">
                null
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column w-100 mtt-3rem">
          <div class="d-flex pen-box">
            <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
            <h6 class="pdf-heading pen-icon-bar">إرشادات المدرب</h6>
          </div>
          <div class="pos-rel-pdf">
            <div class="pen-pos-abs">
              <div class="pen-blue-box">
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـه.</p>
                </div>
                <div class="pdf-pos-rel">
                  <div class="pdf-pos-abs-dot">
                  </div>
                  <p class="pdf-text-white">اعـرض شـريحة التعريـف بالمركـز السـعودي لألعمـال االقتصاديـة، ووضـح
                    للمشـاركين ماهيـة
                    المركـز ورؤيتـه وأهميتـهلألعمـال االقتصاديـة، ووضـح للمشـاركين ماهيـة.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <!-- Profile bar sectio start -->
      <div class="d-flex w-100">
        <div class="">
          <div class="d-flex">
            <div class="pdf-profile pos-rel-pdf">
              <img class="pdf-pp"
                src="https://media.istockphoto.com/id/2061466428/photo/mid-century-modern-dining-area.webp?a=1&b=1&s=612x612&w=0&k=20&c=U1dsdSCgvYwZdGxcWRA3Z_WiF34-1aK98p5BK6mnko0="
                alt="loading">
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-baseline">
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
          </div>
          <div class="bar-2-reponse">
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              الحوار والمناقشة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              المحاضرة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              بطاقات تدريبية
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="bar-3">
                نشاط
              </div>
              <div class="bar-3-num">1</div>
            </div>
            <div class="bar-3-blu-box">
              نبذة عن وزارة االستثمار.
            </div>
          </div>
        </div>
      </div>
      <!-- Profile bar sectio end -->
      <div class="pos-rel-pdf">
        <div class="bar-logo">
          <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
        <div class="bar-max-width">
          <div>
            <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
          </div>
        </div>
      </div>
      <div class="px-5rem">
        <div class="d-flex align-items-baseline">
          <div>
            <div class="sky-num">1.</div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="sky-num">2.</div>
          </div>
          <p class="pdf-text">تنقل بين زمالئك في القاعة وتعرف عليهم واقرأ العبارات المعلقة على لوحة العرض.
          </p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="sky-num">3.</div>
          </div>
          <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى المعلومــات
            المثيــرة التــي
            أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
        </div>
        <div class="d-flex flex-column">
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading mb-3rem">صالحيات وزارة االستثمار</h6>
        </div>
        <h6 class="pdf-heading-blue-mini d-flex">
          مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:
          <div class="symbol">(1)</div>
        </h6>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">1.</div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">2.</div>
          </div>
          <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
            األجنبـي
            فـي المملكـة
            العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
            المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون مــن
            الالئحــة
            التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار آنـذاك رقـم
            )/( وتاريخــه: )// هــ(.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">3.</div>
          </div>
          <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى المعلومــات
            المثيــرة التــي
            أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">1.</div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">2.</div>
          </div>
          <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
            األجنبـي
            فـي المملكـة
            العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
            المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون مــن
            الالئحــة
            التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار آنـذاك رقـم
            )/( وتاريخــه: )// هــ(.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">3.</div>
          </div>
          <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى المعلومــات
            المثيــرة التــي
            أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">1.</div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">2.</div>
          </div>
          <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
            األجنبـي
            فـي المملكـة
            العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
            المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون مــن
            الالئحــة
            التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار آنـذاك رقـم
            )/( وتاريخــه: )// هــ(.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="sky-num">3.</div>
          </div>
          <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى المعلومــات
            المثيــرة التــي
            أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
        </div>
        <div class="d-flex flex-column mtt-3rem">
          <div class="sign-bar"></div>
          <p class="symbol">(1) دليل خدمات وزارة االستثمار، اإلصدار التاسع، )ص 144(. </p>
        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <h6 class="pdf-heading my-5">الجدول المعرفي الذاتي KWL.</h6>
        <div class="bf-box pos-rel-pdf">
          <div class="d-flex pos-abs-bf">
            <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
            <div class="bf-text">
              اإلجابة النموذجية
            </div>
          </div>
          <div class="row p-0">
            <div class="col-md-6 p-0">
              <div class="d-flex flex-column">
                <div class="balance-sheet-header">
                  ماذا أعرف؟
                </div>
                <div class="balance-sheet-box-bf">
                  ن عمليات التستر،
                  والغش التجاري.
                </div>
                <div class="balance-sheet-box-bf">
                  ألنها خارج اختصاص
                  ن عمليات التستر،
                </div>
                <div class="balance-sheet-box-bf">
                  ألنها خارج اختصاص
                </div>
              </div>
            </div>
            <div class="col-md-6 p-0">
              <div class="d-flex flex-column">
                <div class="balance-sheet-header">
                  لسبب أهميتها
                </div>
                <div class="balance-sheet-box-bf">
                  ألنها تمنع ممارسة أعمال خارج اختصاص
                  ا
                </div>
                <div class="balance-sheet-box-bf">
                  ألنها تمنع ممارسة أعمال خارج اختصاص
                  المستثمر، وتحمي من عمليات التستر،
                  والغش التجاري.
                </div>
                <div class="balance-sheet-box-bf">
                  ألنها خارج اختصاص
                  ن عمليات التستر،
                  والغش التجاري.
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <div class="bf-text-sky mtt-3rem mb-3rem">
          التواصل مع وزارة االستثمار:
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">. إيقـاع إحـدى العقوبـات الـواردة فـي المـادة الثانيـة عشـر فـي نظـام االسـتثمار
            األجنبـي
            فـي المملكـة
            العربيــة الســعودية الصــادر بالمرســوم الملكــي رقــم )م/( وتاريخــه: )// هــ( إذا ثبــت بــأن
            المســتثمر األجنبــي قــد ارتكــب مخالفــة مــن المخالفــات الــواردة فــي المــادة العشــرون مــن
            الالئحــة
            التنفيذيـة لنظـام االسـتثمار األجنبـي الصـادر بقـرار مجلـس إدارة الهيئـة العامـة لالسـتثمار آنـذاك رقـم
            )/( وتاريخــه: )// هــ(.
          </p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">ارجــع إلــى مقعــدك وعــرف بنفســك حينمــا يطلــب المــدرب واذكــر إحــدى المعلومــات
            المثيــرة التــي
            أثــارت اهتمامــك حــول وزارة االســتثمار.</p>
        </div>
        <div class="d-flex align-items-baseline mrr-4">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>
        <div class="bf-box pos-rel-pdf mtt-3rem">
          <div class="d-flex pos-abs-bf">
            <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
            <div class="bf-text">
              اإلجابة النموذجية
            </div>
          </div>
          <p class="pdf-text">المعلومات التي سيذكرها المشاركين عن وزارة االستثمار متوفرة في المادة العلمية. </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <!-- Profile bar sectio start -->
      <div class="d-flex w-100">
        <div class="">
          <div class="d-flex">
            <div class="pdf-profile pos-rel-pdf">
              <img class="pdf-pp"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dG3xJm6hiiYXGu9sEq7XBT7a_iY9Jg721zow_XydsVEtqP77iax0bVvvvaUWmagpN-k&usqp=CAU"
                alt="loading">
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-baseline">
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
          </div>
          <div class="bar-2-reponse">
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              الحوار والمناقشة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              المحاضرة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              بطاقات تدريبية
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="bar-3">
                نشاط
              </div>
              <div class="bar-3-num">1</div>
            </div>
            <div class="bar-3-blu-box">
              نبذة عن وزارة االستثمار.
            </div>
          </div>
        </div>
      </div>
      <!-- Profile bar sectio end -->
      <div class="pos-rel-pdf">
        <div class="bar-logo">
          <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
        <div class="bar-max-width">
          <div>
            <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
          </div>
        </div>
      </div>
      <div class="px-6rem">
        <div class="row p-0">
          <div class="col-md-6 p-0">
            <div class="d-flex flex-column">
              <div class="balance-sheet-header">
                ماذا أعرف؟
              </div>
              <div class="balance-sheet-box-bf">
                ن عمليات التستر،
                والغش التجاري.
              </div>
              <div class="balance-sheet-box-bf">
                ألنها خارج اختصاص
                ن عمليات التستر،
              </div>
              <div class="balance-sheet-box-bf">
                ألنها خارج اختصاص
              </div>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="d-flex flex-column">
              <div class="balance-sheet-header">
                لسبب أهميتها
              </div>
              <div class="balance-sheet-box-bf">
                ألنها تمنع ممارسة أعمال خارج اختصاص
                ا
              </div>
              <div class="balance-sheet-box-bf">
                ألنها تمنع ممارسة أعمال خارج اختصاص
                المستثمر، وتحمي من عمليات التستر،
                والغش التجاري.
              </div>
              <div class="balance-sheet-box-bf">
                ألنها خارج اختصاص
                ن عمليات التستر،
                والغش التجاري.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading mb-3rem">خالصة الجلسة التدريبية</h6>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة األخيــرة؛ حيــث
            يتضــح تنــوع
            وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى توافــر
            بيئــة
            آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
            المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
            إجراءاتهــم.</p>
        </div>
        <!-- rectraaingle-diagram start -->
        <div class="d-flex align-items-center flex-column">
          <div class="rect-padding pos-rel-pdf">
            <i class="pos-abs-square-top fa-solid fa-caret-up"></i>
            <div class="outer-div-1">
              <p class="pdf-text-z-index">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
              <div class="inner-div-1"></div>
            </div>
          </div>
          <div class="">
            <div class="outer-div-2">
              <p class="pdf-text-z-index-2">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
              <div class="inner-div-2"></div>
            </div>
          </div>
          <div class="rect-padding pos-rel-pdf">
            <i class="pos-abs-square-bottom fa-solid fa-caret-up"></i>
            <div class="outer-div-1">
              <p class="pdf-text-z-index">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
              <div class="inner-div-1"></div>
            </div>
          </div>
        </div>
        <!-- rectraaingle-diagram end -->
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <!-- Profile bar sectio start -->
      <div class="d-flex w-100">
        <div class="">
          <div class="d-flex">
            <div class="pdf-profile pos-rel-pdf">
              <img class="pdf-pp"
                src="https://images.unsplash.com/photo-1738676469786-6fe6c1acabf2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMXx8fGVufDB8fHx8fA%3D%3D"
                alt="loading">
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-baseline">
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
          </div>
          <div class="bar-2-reponse">
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              الحوار والمناقشة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              المحاضرة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              بطاقات تدريبية
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="bar-3">
                نشاط
              </div>
              <div class="bar-3-num">1</div>
            </div>
            <div class="bar-3-blu-box">
              نبذة عن وزارة االستثمار.
            </div>
          </div>
        </div>
      </div>
      <!-- Profile bar sectio end -->
      <div class="pos-rel-pdf">
        <div class="bar-logo">
          <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
        <div class="bar-max-width">
          <div>
            <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
          </div>
        </div>
      </div>
      <div class="px-6rem">
        <div class="outer-div">
          <p class="pdf-text-z-index">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة
            األخيــرة؛
            حيــث يتضــح تنــوع
            وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى توافــر
            بيئــة
            آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
            المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
            إجراءاتهــم.</p>
          <div class="inner-div"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-6rem">
        <div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك</p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot mrr-4"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot mrr-4"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
        </div>
        <div class="my-3">
          <h6 class="pdf-heading-sky-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ مع نهاية هذا النشاط بإذن الله، ستكون
            قادرا على أن:اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ مع نهاية هذا النشاط بإذن الله، ستكون
            قادرا
            على أن:</p>
        </div>
        <div class="d-flex justify-content-center flex-wrap">
          <div class="d-flex align-items-center mx-2">
            <div class="d-flex flex-column numaric-max-w">
              <div class="numaric-circle-num">01</div>
              <div class="d-flex">
                <div class="numaric-circle"><i class="numaric-icon pi pi-desktop"></i></div>
              </div>
              <p class="pdf-text">النشاط بإذن</p>
            </div>
            <div>
              <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
            </div>
          </div>
          <div class="d-flex align-items-center mx-2">
            <div class="d-flex flex-column numaric-max-w">
              <div class="numaric-circle-num">02</div>
              <div class="d-flex">
                <div class="numaric-circle"><i class="numaric-icon pi pi-android"></i></div>
              </div>
              <p class="pdf-text">النشاط بإذن</p>
            </div>
            <div>
              <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
            </div>
          </div>
          <div class="d-flex align-items-center mx-2">
            <div class="d-flex flex-column numaric-max-w">
              <div class="numaric-circle-num">03</div>
              <div class="d-flex">
                <div class="numaric-circle"><i class="numaric-icon pi pi-wallet"></i></div>
              </div>
              <p class="pdf-text">النشاط بإذن</p>
            </div>
            <div>
              <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
            </div>
          </div>
          <div class="d-flex align-items-center mx-2">
            <div class="d-flex flex-column numaric-max-w">
              <div class="numaric-circle-num">04</div>
              <div class="d-flex">
                <div class="numaric-circle"><i class="numaric-icon pi pi-bitcoin"></i></div>
              </div>
              <p class="pdf-text">النشاط بإذن</p>
            </div>
            <div>
              <i class="numaric-left-arrow fa-solid fa-arrow-left-long"></i>
            </div>
          </div>
          <div class="d-flex align-items-center mx-2">
            <div class="d-flex flex-column numaric-max-w">
              <div class="numaric-circle-num">05</div>
              <div class="d-flex">
                <div class="numaric-circle"><i class="numaric-icon pi pi-apple"></i></div>
              </div>
              <p class="pdf-text">النشاط بإذن</p>
            </div>
          </div>

        </div>
        <div class="bf-box pos-rel-pdf mtt-3rem">
          <div class="d-flex pos-abs-bf">
            <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
            <div class="bf-text">
              اإلجابة النموذجية
            </div>
          </div>
          <p class="pdf-text">المعلومات التي سيذكرها المشاركين عن وزارة االستثمار متوفرة في المادة العلمية. </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading mb-3rem">خالصة الجلسة التدريبية</h6>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة األخيــرة؛ حيــث
            يتضــح تنــوع
            وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى توافــر
            بيئــة
            آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
            المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
            إجراءاتهــم.</p>
        </div>
        <!-- circle diagram start -->
        <div class="container-box mtt-3rem">
          <div class="circle-border">
            <div class="circle pos-rel-pdf">الخدمات الإلكترونية
              <i class="pos-abs-circle-top fa-solid fa-caret-up"></i>
            </div>
          </div>
          <div class="box my-3">
            تطــور تنظيــم االســتثمار فــي المملكــة بشــكل</div>
          <div class="circle-border">
            <div class="circle pos-rel-pdf">مراحل تطور الاستثمار في المملكة
              <i class="pos-abs-circle-bottom fa-solid fa-caret-up"></i>
            </div>
          </div>
        </div>
        <!-- circle-diagram end -->
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <!-- Profile bar sectio start -->
      <div class="d-flex w-100">
        <div class="">
          <div class="d-flex">
            <div class="pdf-profile pos-rel-pdf">
              <img class="pdf-pp"
                src="https://images.unsplash.com/photo-1738676469786-6fe6c1acabf2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMXx8fGVufDB8fHx8fA%3D%3D"
                alt="loading">
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-baseline">
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
          </div>
          <div class="bar-2-reponse">
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              الحوار والمناقشة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              المحاضرة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              بطاقات تدريبية
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="bar-3">
                نشاط
              </div>
              <div class="bar-3-num">1</div>
            </div>
            <div class="bar-3-blu-box">
              نبذة عن وزارة االستثمار.
            </div>
          </div>
        </div>
      </div>
      <!-- Profile bar sectio end -->
      <div class="pos-rel-pdf">
        <div class="bar-logo">
          <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
        <div class="bar-max-width">
          <div>
            <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
          </div>
        </div>
      </div>
      <div class="px-6rem">
        <div class="grey-box-pdf my-3">
          <div class="border-box-pdf">
            <div class="d-flex justify-content-center pos-rel-pdf">
              <div class="border-heading">
                مجموعة أنواع االستثمار
              </div>
            </div>
            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
            <div class="d-flex flex-column">
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
            </div>
            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
            <div class="d-flex flex-column">
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <!-- Profile bar sectio start -->
      <div class="d-flex w-100">
        <div class="">
          <div class="d-flex">
            <div class="pdf-profile pos-rel-pdf">
              <img class="pdf-pp"
                src="https://images.unsplash.com/photo-1738676469786-6fe6c1acabf2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMXx8fGVufDB8fHx8fA%3D%3D"
                alt="loading">
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-baseline">
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
          </div>
          <div class="bar-2-reponse">
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              الحوار والمناقشة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              المحاضرة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              بطاقات تدريبية
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="bar-3">
                نشاط
              </div>
              <div class="bar-3-num">1</div>
            </div>
            <div class="bar-3-blu-box">
              نبذة عن وزارة االستثمار.
            </div>
          </div>
        </div>
      </div>
      <!-- Profile bar sectio end -->
      <div class="pos-rel-pdf">
        <div class="bar-logo">
          <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
        <div class="bar-max-width">
          <div>
            <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
          </div>
        </div>
      </div>
      <div class="px-6rem">
        <div class="row p-0 my-3">
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
          <div class="col-md-4 p-0">
            <div class="d-flex align-items-center flex-column grey-logo-box">
              <img class="grey-logo-img" src="../../../../assets/logo.png" alt="loading">
              <p class="grey-logo-text">الترخيص الزراعي.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="grey-box-pdf my-3">
          <div class="border-box-pdf">
            <div class="d-flex justify-content-center pos-rel-pdf">
              <div class="border-heading">
                مجموعة أنواع االستثمار
              </div>
            </div>
            <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
            <div class="d-flex flex-column">
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
              <div class="papper-dotts"></div>
            </div>
            <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
            <div class="row row-bg">
              <div class="col-md-6 p-0">
                <div class="d-flex flex-column">
                  <div class="balance-sheet-header">
                    ماذا أعرف؟
                  </div>
                  <div class="balance-sheet-box-bf">
                    ن عمليات التستر،
                    والغش التجاري.
                  </div>
                  <div class="balance-sheet-box-bf">
                    ألنها خارج اختصاص
                    ن عمليات التستر،
                  </div>
                  <div class="balance-sheet-box-bf">
                    ألنها خارج اختصاص
                  </div>
                </div>
              </div>
              <div class="col-md-6 p-0">
                <div class="d-flex flex-column">
                  <div class="balance-sheet-header">
                    لسبب أهميتها
                  </div>
                  <div class="balance-sheet-box-bf">
                    ألنها تمنع ممارسة أعمال خارج اختصاص
                    ا
                  </div>
                  <div class="balance-sheet-box-bf">
                    ألنها تمنع ممارسة أعمال خارج اختصاص
                    المستثمر، وتحمي من عمليات التستر،
                    والغش التجاري.
                  </div>
                  <div class="balance-sheet-box-bf">
                    ألنها خارج اختصاص
                    ن عمليات التستر،
                    والغش التجاري.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="bf-box pos-rel-pdf mtt-3rem">
          <div class="d-flex pos-abs-bf">
            <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
            <div class="bf-text">
              اإلجابة النموذجية
            </div>
          </div>
          <div class="grey-box-pdf my-3">
            <div class="border-box-pdf">
              <div class="d-flex justify-content-center pos-rel-pdf">
                <div class="border-heading">
                  مجموعة أنواع االستثمار
                </div>
              </div>
              <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
              <div class="d-flex align-items-baseline mrr-4">
                <div>
                  <div class="list-dot"></div>
                </div>
                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                  فـي
                  توضيـح
                  مـا</p>
              </div>
              <div class="d-flex align-items-baseline mrr-4">
                <div>
                  <div class="list-dot"></div>
                </div>
                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                  فـي
                  توضيـح
                  مـا</p>
              </div>
              <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>

            </div>
          </div>
          <div class="grey-box-pdf my-3">
            <div class="border-box-pdf">
              <div class="d-flex justify-content-center pos-rel-pdf">
                <div class="border-heading">
                  مجموعة أنواع االستثمار
                </div>
              </div>
              <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
              <div class="d-flex align-items-baseline mrr-4">
                <div>
                  <div class="list-dot"></div>
                </div>
                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                  فـي
                  توضيـح
                  مـا</p>
              </div>
              <div class="d-flex align-items-baseline mrr-4">
                <div>
                  <div class="list-dot"></div>
                </div>
                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                  فـي
                  توضيـح
                  مـا</p>
              </div>
              <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
            </div>
          </div>
          <div class="grey-box-pdf my-3">
            <div class="border-box-pdf">
              <div class="d-flex justify-content-center pos-rel-pdf">
                <div class="border-heading">
                  مجموعة الكيانات القانونية األكثر طلبا لتراخيص
                  االستثمار في وزارة االستثمار
                </div>
              </div>
              <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
              <div class="d-flex align-items-baseline mrr-4">
                <div>
                  <div class="list-dot"></div>
                </div>
                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                  فـي
                  توضيـح
                  مـا</p>
              </div>
              <div class="d-flex align-items-baseline mrr-4">
                <div>
                  <div class="list-dot"></div>
                </div>
                <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه
                  فـي
                  توضيـح
                  مـا</p>
              </div>
              <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="bf-box pos-rel-pdf mtt-3rem">
          <div class="d-flex pos-abs-bf">
            <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
            <div class="bf-text">
              اإلجابة النموذجية
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <h6 class="pdf-heading-sky-mini my-2">عزيزي المدرب: </h6>
          <div class="d-flex align-items-baseline mrr-4">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">حقيبـة المـدرب، فهـي ستسـاهم بـإذن اللـه فـي توضيـح
              مـا</p>
          </div>
          <div class="d-flex align-items-baseline mrr-4">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text"> اطلـع علـى اإلرشـاداتحقيبـةاللـه فـي توضيـح
              مـا</p>
          </div>
          <div class="d-flex align-items-baseline mrr-4">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text"> اطلـع علـى اإلرشـادات والتوجيهـات فـي حقيبـة المـدرب،اللـه فـي
              مـا</p>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading mb-3rem">خالصة الجلسة التدريبية</h6>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">تطــور تنظيــم االســتثمار فــي المملكــة بشــكل متســارع فــي الفتــرة األخيــرة؛ حيــث
            يتضــح تنــوع
            وانفتــاح االقتصــاد فــي المملكــة وتطــور التشــريعات المنظمــة لالســتثمار، إضافــة إلــى توافــر
            بيئــة
            آمنـة ومسـتقرة، كمـا سـعت الـوزارة إلـى تقديـم الخدمـات بشـكل إلكترونـي للمسـتثمرين حسـب نـوع
            المســتثمر )حالــي، جديــد( وأتمتــة العديــد مــن هــذه الخدمــات لخدمــة المســتثمرين وتســريع
            إجراءاتهــم.</p>
        </div>
        <!-- space circle diagram start -->
        <div class="container-fluid">
          <div class="container d-flex justify-content-center my-5">
            <div class="main-circle-border">
              <div class="main-circle">
                <p class="pdf-text-z-index-circle">تطــور تنظيــم االســتثمار فــي</p>
                <div class="main-circle-inner"></div>
              </div>

              <div class="pos-rel-pdf">
                <div class="mini-circle-pos-abs-1">
                  <div class="main-circle-mini-1">
                    <p class="pdf-text-z-index-mini-1">تطــور تنظيــفــي</p>
                    <div class="main-circle-mini-1-inner"></div>
                    <i class="mini-circle-arrow-1 fa-solid fa-arrow-turn-down"></i>
                  </div>
                </div>
                <div class="mini-circle-pos-abs-2">
                  <div class="main-circle-mini-1">
                    <p class="pdf-text-z-index-mini-1">تطــور تنظيــفــي</p>
                    <div class="main-circle-mini-1-inner"></div>
                    <i class="mini-circle-arrow-2 fa-solid fa-arrow-turn-down"></i>
                  </div>
                </div>
                <div class="mini-circle-pos-abs-3">
                  <div class="main-circle-mini-1">
                    <p class="pdf-text-z-index-mini-1">تطــور تنظيــفــي</p>
                    <div class="main-circle-mini-1-inner"></div>
                    <i class="mini-circle-arrow-3 fa-solid fa-arrow-turn-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- space circle-diagram end -->
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-5rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <div class="d-flex align-items-baseline mtt-3rem">
          <div>
            <div class="sky-num">1.</div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل اســمك
            ومعلومــة أثــارت
            انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
        </div>

        <div class="my-5">
          <div class="d-flex">
            <div class="col-boxes-w-25 bg-25">
              الترخيص الزراعي:
            </div>
            <div class="col-boxes-w-75 bg-25">
              يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
              الهندسية في المملكة العربية السعودية.
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-5rem">
        <div class="d-flex">
          <div class="b-bottom"></div>
          <p class="pdf-text-desc">خدمات وزارة االسـتثمار</p>
        </div>
        <!-- logo and detail section start -->
        <div class="d-flex justify-content-center my-5">
          <h6 class="pdf-heading">خالصة الجلسة التدريبية</h6>
        </div>
        <h6 class="pdf-heading-sky-mini">رحلة المستثمر:</h6>
        <div class="d-flex">
          <p class="pdf-text-sky">المرحلة األولى:&nbsp;</p>
          <p class="pdf-text">إصدار ترخيص االستثمار</p>
        </div>
        <p class="pdf-text-bold">المتطلبات:</p>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> علــى المــادة العلميــة بعنــوان</p>
        </div>
        <p class="pdf-text-bold">الجهة المسؤولة: </p>

        <div class="d-flex justify-content-start align-items-center flex-wrap">
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/nelcLogo2020.png" alt="loading">
          </div>
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/PRC1.png" alt="loading">
          </div>
        </div>
        <!-- logo and detail section end -->
        <!-- logo and detail section start -->
        <h6 class="pdf-heading-sky-mini">رحلة المستثمر:</h6>
        <div class="d-flex">
          <p class="pdf-text-sky">المرحلة األولى:&nbsp;</p>
          <p class="pdf-text">إصدار ترخيص االستثمار</p>
        </div>
        <p class="pdf-text-bold">المتطلبات:</p>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> علــى المــادة العلميــة بعنــوان</p>
        </div>
        <p class="pdf-text-bold">الجهة المسؤولة: </p>

        <div class="d-flex justify-content-start align-items-center flex-wrap">
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/nelcLogo2020.png" alt="loading">
          </div>
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/PRC1.png" alt="loading">
          </div>
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/logo.png" alt="loading">
          </div>
        </div>
        <!-- logo and detail section end -->
        <!-- logo and detail section start -->
        <h6 class="pdf-heading-sky-mini">رحلة المستثمر:</h6>
        <div class="d-flex">
          <p class="pdf-text-sky">المرحلة األولى:&nbsp;</p>
          <p class="pdf-text">إصدار ترخيص االستثمار</p>
        </div>
        <p class="pdf-text-bold">المتطلبات:</p>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن </p>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text"> علــى المــادة العلميــة بعنــوان</p>
        </div>
        <p class="pdf-text-bold">الجهة المسؤولة: </p>

        <div class="d-flex justify-content-start align-items-center flex-wrap">
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/logo.png" alt="loading">
          </div>
          <div class="sbc-img">
            <img class="sbc-img-size" src="../../../../assets/btn 1.png" alt="loading">
          </div>
        </div>
        <!-- logo and detail section end -->


      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="d-flex justify-content-center">
          <h6 class="pdf-heading mb-3rem">تصنيف خدمات وزارة االستثمار
          </h6>
        </div>
        <div class="row p-0">
          <div class="col-md-6 pr-3rem">
            <h6 class="pdf-heading-sky-mini">إصدار التراخيص: </h6>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">الترخيص الصناعي.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">الترخيص الصناعي.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">الترخيص الصناعي.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">الترخيص الصناعي.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">الترخيص الصناعي.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text"> ترخيص تجاري بشريك سعودي</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">ترخيص مكتب علمي وفني.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">شهادة مؤقتة للتقديم
                على عطاءات المشاريع
                الحكومية.</p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">إصــدار ترخيــص مؤقــت </p>
            </div>
            <div class="d-flex align-items-baseline mrr-4">
              <div>
                <div class="list-dot"></div>
              </div>
              <p class="pdf-text">نفيــذ عقــد حكومــي/ شــبه
                حكومــي واحــد.</p>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <!-- second space circle diagram start -->
            <div class="container-fluid">
              <div class="container d-flex justify-content-end  my-5">
                <div class="main-circle-border-2nd-space">
                  <div class="main-circle-2nd-space">
                    <p class="pdf-text-z-index-circle-2nd-space">تطــور تنظيــم االســتثمار فــي</p>
                    <div class="main-circle-inner-2nd-space"></div>
                  </div>

                  <div class="pos-rel-pdf">
                    <div class="mini-circle-pos-abs-1-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">1</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">إصدار
                          التراخيص
                        </p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>

                    <div class="mini-circle-pos-abs-2-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">2</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">تعديل
                          التراخيص
                        </p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>

                    <div class="mini-circle-pos-abs-3-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">3</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">تجديد
                          التراخيص</p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>

                    <div class="mini-circle-pos-abs-4-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">4</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">تملك وبيع
                          العقار
                        </p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>

                    <div class="mini-circle-pos-abs-5-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">5</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">تحويل
                          التراخيص الى
                          وطني 100 %
                        </p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>

                    <div class="mini-circle-pos-abs-6-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">6</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">إلغاء
                          الترخيص</p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>

                    <div class="mini-circle-pos-abs-7-2nd-space">
                      <div class="pos-rel-pdf">
                        <div class="mini-circle-num-pos-abs">
                          <span class="mini-num-zindex">7</span>
                        </div>
                      </div>
                      <div class="main-circle-mini-1-2nd-space">
                        <p class="pdf-text-z-index-mini-1-2nd-space">خدمات وزارة
                          االستثمار الخاصة
                          بمركز خدمات
                          المستثمرين</p>
                        <div class="main-circle-mini-1-inner-2nd-space"></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!-- second space circle-diagram end -->
          </div>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بواسطة القطارات المترو داخل المدن.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بالحافالت داخل المدن.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">الترخيص للمستفيدين من الحملة التصحيحية للبرنامج الوطني لمكافحة التستر التجاري.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">ترخيص نشاط وكالء االستقدام وتأجير خدمات العمالة المنزلية.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بواسطة القطارات المترو داخل المدن.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">خدمة إصدار ترخيص النقل العام البري بالحافالت داخل المدن.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">الترخيص للمستفيدين من الحملة التصحيحية للبرنامج الوطني لمكافحة التستر التجاري.</p>
          </div>
          <div class="d-flex align-items-baseline mrr-1-3">
            <div>
              <div class="list-dot"></div>
            </div>
            <p class="pdf-text">ترخيص نشاط وكالء االستقدام وتأجير خدمات العمالة المنزلية.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <div class="px-5rem">
        <div class="bf-box pos-rel-pdf mtt-3rem">
          <div class="d-flex pos-abs-bf">
            <img class="pen-icon" src="../../../../assets/icons/Email/24@1.5x.svg" alt="loading">
            <div class="bf-text">
              اإلجابة النموذجية
            </div>
          </div>
          <div class="grey-box-pdf my-3">
            <div class="border-box-pdf">
              <div class="d-flex justify-content-center pos-rel-pdf">
                <div class="border-heading">
                  مجموعة أنواع االستثمار
                </div>
              </div>
              <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
              <div class="d-flex flex-column">
                <div class="d-flex flex-column mrr-4">
                  <div class="d-flex align-items-baseline">
                    <div class="d-flex">
                      <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">جـوز للمكتـب دراسـة األسـواق بالنسـبة لنـوع نشـاط الشــركة، ويمكـن إعـداد
                      تقاريـر
                      ً عـن هـذه الدراسـة للمركـز الرئيـس، وعلـى المكتـب أن يقـدم لوزارة االسـتثمار ملخصا
                      ً سـنويا عـن نشـاطه. </p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                </div>
              </div>
              <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>

            </div>
          </div>
          <div class="grey-box-pdf my-3">
            <div class="border-box-pdf">
              <div class="d-flex justify-content-center pos-rel-pdf">
                <div class="border-heading">
                  مجموعة أنواع االستثمار
                </div>
              </div>
              <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
              <div class="d-flex flex-column">
                <div class="d-flex flex-column mrr-4">
                  <div class="d-flex align-items-baseline">
                    <div class="d-flex">
                      <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">جـوز للمكتـب دراسـة األسـواق بالنسـبة لنـوع نشـاط الشــركة، ويمكـن إعـداد
                      تقاريـر
                      ً عـن هـذه الدراسـة للمركـز الرئيـس، وعلـى المكتـب أن يقـدم لوزارة االسـتثمار ملخصا
                      ً سـنويا عـن نشـاطه. </p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                </div>
              </div>
              <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
            </div>
          </div>
          <div class="grey-box-pdf my-3">
            <div class="border-box-pdf">
              <div class="d-flex justify-content-center pos-rel-pdf">
                <div class="border-heading">
                  مجموعة الكيانات القانونية األكثر طلبا لتراخيص
                  االستثمار في وزارة االستثمار
                </div>
              </div>
              <p class="pdf-text my-3">ما أنواع االستثمار في المملكة؟ </p>
              <div class="d-flex flex-column">
                <div class="d-flex flex-column mrr-4">
                  <div class="d-flex align-items-baseline">
                    <div class="d-flex">
                      <div class="list-dot"></div>
                    </div>
                    <p class="pdf-text">جـوز للمكتـب دراسـة األسـواق بالنسـبة لنـوع نشـاط الشــركة، ويمكـن إعـداد
                      تقاريـر
                      ً عـن هـذه الدراسـة للمركـز الرئيـس، وعلـى المكتـب أن يقـدم لوزارة االسـتثمار ملخصا
                      ً سـنويا عـن نشـاطه. </p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                  <div class="d-flex align-items-baseline mrr-4">
                    <div>
                      <div class="border-dot"></div>
                    </div>
                    <p class="pdf-text"> اطلـع علـى اإلرشـادات</p>
                  </div>
                </div>
              </div>
              <p class="pdf-text">ما أنواع االستثمار في المملكة؟ </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="d-flex p-6rem">
        <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
        <div class="b-bottom"></div>
      </div>
      <!-- Profile bar sectio start -->
      <div class="d-flex w-100">
        <div class="">
          <div class="d-flex">
            <div class="pdf-profile pos-rel-pdf">
              <img class="pdf-pp"
                src="https://media.istockphoto.com/id/2061466428/photo/mid-century-modern-dining-area.webp?a=1&b=1&s=612x612&w=0&k=20&c=U1dsdSCgvYwZdGxcWRA3Z_WiF34-1aK98p5BK6mnko0="
                alt="loading">
            </div>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex align-items-baseline">
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
            <div class="pp-bar-width-rel">
              <div class="pp-bar-abs"></div>
            </div>
            <div class="d-flex flex-column w-100px">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              <h6 class="pp-bar-text">10 دقيقة</h6>
            </div>
          </div>
          <div class="bar-2-reponse">
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              الحوار والمناقشة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              المحاضرة
            </div>
            <div class="bar-2">
              <img class="pp-bar-icon" src="../../../../assets/icons/SBC/clock.svg" alt="loading">
              بطاقات تدريبية
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column">
              <div class="bar-3">
                نشاط
              </div>
              <div class="bar-3-num">1</div>
            </div>
            <div class="bar-3-blu-box">
              نبذة عن وزارة االستثمار.
            </div>
          </div>
        </div>
      </div>
      <!-- Profile bar sectio end -->
      <div class="pos-rel-pdf">
        <div class="bar-logo">
          <img class="bar-logo-img" src="../../../../assets/icons/SBC/mountain.svg" alt="loading">
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column align-items-center mtt-3rem">
        <div class="bar-max-width">
          <div>
            <h6 class="pdf-heading-blue-mini">مع نهاية هذا النشاط بإذن الله، ستكون قادرا على أن:</h6>
          </div>
          <div class="d-flex align-items-baseline">
            <div>
              <div class="list-dot mrr-4"></div>
            </div>
            <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي</p>
          </div>
        </div>
      </div>
      <div class="px-5rem">
        <div class="d-flex">
          <div class="d-flex align-items-baseline">
            <div>
              <div class="sky-num">1.</div>
            </div>
            <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان )نبــذة عــن وزارة االســتثمار(، وســجل
              اســمك
              ومعلومــة أثــارت
              انتباهــك عــن الــوزارة فــي إحــدى األوراق الالصقــة وعلقهــا علــى لوحــة العــرض</p>
          </div>
          <div>
            <img class="qr-code-2"
              src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
              alt="loading">
          </div>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
        </div>
        <div class="d-flex flex-column">
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
        </div>
        <div class="d-flex align-items-baseline">
          <div>
            <div class="list-dot"></div>
          </div>
          <p class="pdf-text">اإلرشـادات والتوجيهـات وضِ عـت لمسـاعدتك فـي تنفيـذ األنشـطة</p>
        </div>
        <div class="d-flex flex-column">
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
          <div class="papper-dotts"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-6rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>
        <div class="d-flex mtt-3rem mb-3rem">
          <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
          <h6 class="pdf-heading-bg">المراجع والمصادر</h6>
        </div>

        <div class="row p-0">
          <div class="qr-bar-active">
            <div class="d-flex align-items-baseline">
              <div>
                <div class="sky-num">1.</div>
              </div>
              <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي إحــدى األوراق
                الالصقــة</p>
            </div>
          </div>
          <div class="qr-bar">
            <div class="d-flex align-items-baseline">
              <div>
                <div class="sky-num">1.</div>
              </div>
              <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي إحــدى األوراق
                الالصقــة</p>
            </div>
          </div>
          <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0">
            <div class="d-flex align-items-baseline">
              <div>
                <div class="sky-num">1.</div>
              </div>
              <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي إحــدى األوراق
                الالصقــة</p>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="d-flex justify-content-center align-items-center">
              <img class="qr-code-3"
                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                alt="loading">
            </div>
          </div>
          <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0 qr-bar-col-active">
            <div class="d-flex align-items-baseline">
              <div>
                <div class="sky-num">1.</div>
              </div>
              <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي إحــدى األوراق
                الالصقــة</p>
            </div>
          </div>
          <div class="col-md-6 p-0 qr-bar-col-active">
            <div class="d-flex justify-content-center align-items-center">
              <img class="qr-code-3"
                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                alt="loading">
            </div>
          </div>
          <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0">
            <div class="d-flex align-items-baseline">
              <div>
                <div class="sky-num">1.</div>
              </div>
              <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي إحــدى األوراق
                الالصقــة</p>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="d-flex justify-content-center align-items-center">
              <img class="qr-code-3"
                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                alt="loading">
            </div>
          </div>
          <div class="col-md-6 d-flex justify-content-center align-items-center qr-bar-col p-0">
            <div class="d-flex align-items-baseline">
              <div>
                <div class="sky-num">1.</div>
              </div>
              <p class="pdf-text">اطلــع علــى المــادة العلميــة بعنــوان نتباهــك عــن الــوزارة فــي إحــدى األوراق
                الالصقــة</p>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="d-flex justify-content-center align-items-center">
              <img class="qr-code-3"
                src="https://media.istockphoto.com/id/828088276/vector/qr-code-illustration.jpg?s=612x612&w=0&k=20&c=FnA7agr57XpFi081ZT5sEmxhLytMBlK4vzdQxt8A70M="
                alt="loading">
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h bg-white-pdf my-2">
    <div class="p-pdf-bottom">
      <div class="px-5rem">
        <div class="d-flex">
          <img class="pdf-page-logo" src="../../../../assets/new-logo/SCBCLOGO-COLOR.svg" alt="loading">
          <div class="b-bottom"></div>
        </div>

        <div class="d-flex mtt-3rem mb-3rem">
          <img class="pen-icon" src="../../../../assets/icons/SBC/penpaper.svg" alt="loading">
          <h6 class="pdf-heading-bg">مالحظات</h6>
        </div>

        <div class="my-5">
          <div class="d-flex">
            <div class="col-boxes-w-75 bg-25">
              المالحظة
            </div>
            <div class="col-boxes-w-25 bg-25">
              رقم الصفحة
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-boxes-w-75">
              <div class="col-boxes">
                <p class="pdf-text">يتم إصدار هذا الترخيص للشركات التي تقدم خدمات االستشارة
                  الهندسية في المملكة العربية السعودية.</p>
              </div>
            </div>
            <div class="col-boxes-w-25">
              <div class="col-boxes">
                <p class="pdf-text">الترخيص الزراعي: </p>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner-2 bg-blue d-flex justify-content-center align-items-center">
      <img class="vector brightness" src="../../../../assets/picture-removebg-preview.png" alt="loading">
    </div>
  </div>

  <div class="container max-w-h banner my-2">
    <div class="bg-banner">
      <div class="footer-pdf">

        <div class="d-flex mx-4">
          <img class="footer-vector brightness" src="../../../../assets/picture-removebg-preview.png" alt="loading">
        </div>

        <div class="d-flex align-items-end flex-column mx-4">
          <div class="d-flex mb-2">
            <div class="d-flex align-items-center">
              <span class="footer-white">199080</span>
              <i class="mx-2 footer-white fa-brands fa-whatsapp"></i>
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <span class="footer-white">+99611228 2881</span>
              <i class="mx-2 footer-white fa-solid fa-headphones"></i>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-end flex-column mx-4">
          <div class="d-flex mb-2">
            <div class="d-flex align-items-center mll-2">
              <span class="footer-white">BUSINESS.SA</span>
              <i class="mx-2 footer-white fa-solid fa-globe"></i>
            </div>
            <div class="d-flex align-items-center">
              <span class="footer-white">BCGOV_SA</span>
              <i class="mx-2 footer-white pi pi-twitter"></i>
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex align-items-center">
              <span class="footer-white">SAUDI BUSINESS CENTER</span>
              <i class="mx-1 footer-white fa-brands fa-instagram"></i>
              <i class="mx-1 footer-white fa-brands fa-linkedin"></i>
              <i class="mx-1 footer-white fa-brands fa-youtube"></i>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>


</div>

<!-- faisal PDF DESIGN WORK END -->





















































<!-- new training design start -->
<div class="container-fluid p-0">
  <!-- header code start -->
  <div class="main-header row">
    <div class="col-md-4 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-start">
          <h6 class="m-h6">finance for non financials</h6>
          <div>
            <div class="edit-pen">
              <img class="" src="../../../../assets/icones-2025/edit.png" alt="loading..." />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-start">
          <p class="m-p">
            استنكار النشوة وتمجيد الألم نشأت بالفعل، وسأعرض لك التفاصيل لتكتشف
            حقيقة وأساس تلك السعادة البشرية، فلا أحد يرفض أو يكره أو يتجنب
            الشعور بالسعادة، ولكن بفضل هؤلاء الأشخاص
          </p>
          <div>
            <div class="edit-pen">
              <img class="" src="../../../../assets/icones-2025/edit.png" alt="loading..." />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mob-web-flex col-md-8 col-12">
      <div class="mob-web-flex">
        <div class="profile">
          <div class="d-flex">
            <div class="d-flex justify-content-center align-items-center">
              <img class="profile-img"
                src="https://static.vecteezy.com/system/resources/thumbnails/029/364/941/small_2x/3d-carton-of-boy-going-to-school-ai-photo.jpg"
                alt="loading..." />
            </div>
            <div class="profile-text">
              <p class="profile-p">Coach</p>
              <h6 class="profile-h6">Zaid Izhar Siddiq</h6>
            </div>
          </div>
        </div>
        <div class="start-end-date">
          <div class="d-flex justify-content-between">
            <div class="start-date">
              <div class="d-flex align-items-center">
                <img class="start-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading..." />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-30-2024</div>
            </div>
            <div class="d-flex align-items-center mx-2">
              <i class="full-stop"></i>
              <div class="time-bar"></div>
              <i class="fa-solid fa-play icon-purple"></i>
            </div>
            <div class="end-date">
              <div class="d-flex align-items-center">
                <img class="start-icone" src="../../../../assets/icones-2025/avg_pace.png" alt="loading..." />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-01-2024</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- header code end -->

  <!-- training content code start -->
  <div class="content">
    <div class="d-flex justify-content-end">
      <div class="d-flex multi-btn">
        <div class="multi-btn-active">
          Syncronius
          <img class="mx-2 mob-width" src="../../../../assets/icones-2025/calendar_month.png" alt="loading..." />
        </div>
        <div class="multi-btn-dactive">
          Asyncronius
          <img class="mx-2 mob-width" src="../../../../assets/icones-2025/list_alt.png" alt="loading..." />
        </div>
      </div>
    </div>
    <div class="d-flex pos-rel flex-column">
      <div class="sticky-border"></div>
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="cross">
              <img class="" src="../../../../assets/icones-2025/close_small.png" alt="loading..." />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data">
          <div class="training-cards">
            <div class="training-cards-img pos-rel">
              <span class="red-dot"></span>
              <img class="card-img"
                src="https://plus.unsplash.com/premium_vector-1711987493316-bbdbb5cb530a?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name 222">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1586115176305-0dbffc809ed5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1530912780732-0d2507ded3e8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards">
            <div class="training-cards-img">
              <img class="card-img" src="https://i.pinimg.com/736x/68/8d/d3/688dd325dbbdc238f4b70caffe77a5af.jpg"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- training content code end -->

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->

      <!-- training active content code start -->
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="lock">
              <img class="" src="../../../../assets/icones-2025/lock.png" alt="loading..." />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data training-data-active">
          <div class="training-cards training-cards-active">
            <div class="training-cards-img pos-rel">
              <span class="red-dot"></span>
              <img class="card-img"
                src="https://plus.unsplash.com/premium_vector-1711987493316-bbdbb5cb530a?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name 777">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1586115176305-0dbffc809ed5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1530912780732-0d2507ded3e8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img" src="https://i.pinimg.com/736x/68/8d/d3/688dd325dbbdc238f4b70caffe77a5af.jpg"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->

      <!-- training active content code end -->

      <!-- training active content code start -->
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="lock">
              <img class="" src="../../../../assets/icones-2025/lock.png" alt="loading..." />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data training-data-active">
          <div class="training-cards training-cards-active">
            <div class="training-cards-img pos-rel">
              <span class="red-dot"></span>
              <img class="card-img"
                src="https://plus.unsplash.com/premium_vector-1711987493316-bbdbb5cb530a?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name 666">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1559583985-c80d8ad9b29f?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1586115176305-0dbffc809ed5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1530912780732-0d2507ded3e8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img"
                src="https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>

          <div class="training-cards training-cards-active">
            <div class="training-cards-img">
              <img class="card-img" src="https://i.pinimg.com/736x/68/8d/d3/688dd325dbbdc238f4b70caffe77a5af.jpg"
                alt="loading..." />
            </div>
            <div class="d-flex flex-column justify-content-between mx-2">
              <div class="card-data">
                <div class="session-name">finance for non financials</div>
                <div class="session-icon">
                  <img class="" src="../../../../assets/icones-2025/pending_actions.png" alt="loading..." />
                </div>
              </div>
              <div class="card-data">
                <div class="d-flex flex-column">
                  <div class="date-file-heading">Session</div>
                  <div class="date-file">08.00&nbsp;-&nbsp;09.00</div>
                </div>
                <div class="d-flex align-items-end">
                  <div class="online">Online</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->

      <!-- training active content code end -->
    </div>
  </div>
</div>

<div class="container-fluid p-0">
  <!-- header code start -->
  <div class="main-header row">
    <div class="col-md-4 col-12">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-start">
          <h6 class="m-h6">finance for non financials</h6>
          <div>
            <div class="edit-pen">
              <img class="" src="../../../../assets/icones-2025/edit.png" alt="loading..." />
            </div>
          </div>
        </div>
        <div class="d-flex align-items-start">
          <p class="m-p">
            استنكار النشوة وتمجيد الألم نشأت بالفعل، وسأعرض لك التفاصيل لتكتشف
            حقيقة وأساس تلك السعادة البشرية، فلا أحد يرفض أو يكره أو يتجنب
            الشعور بالسعادة، ولكن بفضل هؤلاء الأشخاص
          </p>
          <div>
            <div class="edit-pen">
              <img class="" src="../../../../assets/icones-2025/edit.png" alt="loading..." />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mob-web-flex col-md-8 col-12">
      <div class="mob-web-flex">
        <div class="profile">
          <div class="d-flex">
            <div class="d-flex justify-content-center align-items-center">
              <img class="profile-img"
                src="https://static.vecteezy.com/system/resources/thumbnails/029/364/941/small_2x/3d-carton-of-boy-going-to-school-ai-photo.jpg"
                alt="loading..." />
            </div>
            <div class="profile-text">
              <p class="profile-p">Coach</p>
              <h6 class="profile-h6">Zaid Izhar Siddiq</h6>
            </div>
          </div>
        </div>
        <div class="start-end-date">
          <div class="d-flex justify-content-between">
            <div class="start-date">
              <div class="d-flex align-items-center">
                <img class="start-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading..." />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-30-2024</div>
            </div>
            <div class="d-flex align-items-center mx-2">
              <i class="full-stop"></i>
              <div class="time-bar"></div>
              <i class="fa-solid fa-play icon-purple"></i>
            </div>
            <div class="end-date">
              <div class="d-flex align-items-center">
                <img class="start-icone" src="../../../../assets/icones-2025/avg_pace.png" alt="loading..." />
                <p class="start-end-p">Start date</p>
              </div>
              <div class="date">Nov-01-2024</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- header code end -->

  <!-- ADD training content code start -->
  <div class="content">
    <div class="d-flex justify-content-end">
      <div class="d-flex multi-btn">
        <div class="multi-btn-active">
          Syncronius
          <img class="mx-2 mob-width" src="../../../../assets/icones-2025/calendar_month.png" alt="loading..." />
        </div>
        <div class="multi-btn-dactive">
          Asyncronius
          <img class="mx-2 mob-width" src="../../../../assets/icones-2025/list_alt.png" alt="loading..." />
        </div>
      </div>
    </div>
    <div class="d-flex pos-rel flex-column">
      <div class="sticky-border"></div>
      <div class="training-bar d-flex">
        <div class="main-content-bar">
          <div class="date-box pos-rel">
            <div class="cross">
              <img class="" src="../../../../assets/icones-2025/close_small.png" alt="loading..." />
            </div>
            <h6 class="month">Nov</h6>
            <h6 class="day">07</h6>
            <h6 class="year">2024</h6>
          </div>
        </div>
        <div class="training-data">
          <div class="training-cards">
            <div class="add-training-cards">
              <div>
                <img class="" src="../../../../assets/icones-2025/add_2.png" alt="loading..." />
              </div>
              <div class="add-training-text">Add Materials</div>
            </div>
          </div>
        </div>
      </div>
      <!-- training content code end -->

      <!-- dotted borders code start -->
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <div class="d-flex">
        <div class="dotted-date pos-rel">
          Nov-3
          <span class="dott"></span>
        </div>
        <div class="dotted-border"></div>
      </div>
      <!-- dotted borders code End -->
    </div>
  </div>
</div>
<!-- new training design end -->




<!-- osama 3pages design start -->
<div class="container-fluid p-0">
  <!-- header code start -->
  <div class="mini-banner">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="pos-rel">
        <h3 class="mini-banner-text">إنشاء تقرير</h3>
      </div>
      <div class="back-arrow-btn">
        <img class="" src="../../../../assets/icones-2025/arrow_back.png" alt="loading">
      </div>
    </div>
  </div>
  <!-- header code end -->
  <!-- content start -->
  <div class="content-grey">
    <div class="row p-0">
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/apartment.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div>
            <input class="input-2025 my-2" type="text" id="title" placeholder="وزارة الاستثمار" formControlName="title"
              pInputText>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/person_2.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div>
            <input class="input-2025 my-2" type="text" id="title" placeholder="وزارة الاستثمار" formControlName="title"
              pInputText>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div class="d-flex">
            <div class="tab-white-box my-2">
              <div class="inner-data-border">
                <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                <div>Jul - 27 -2024</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
              <div class="inner-data">
                <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                <div>8:10 pm</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div class="d-flex">
            <div class="tab-white-box my-2">
              <div class="inner-data-border">
                <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                <div>Jul - 27 -2024</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
              <div class="inner-data">
                <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                <div>8:10 pm</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- table start -->
    <div class="mask">
      <div>
        <table>
          <thead>
            <tr>
              <th>العنوان</th>
              <th>العنوان</th>
              <th>العنوان</th>
              <th>تاريخ البدء</th>
              <th>تاريخ البدء</th>
              <th>خيارات أخرى</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div class="tab-num">01</div>
                  </div>
                  <div class="tab-profile">
                    <img class="tab-profile-img" src="../../../../assets/icones-2025/Group-61302.png" alt="loading">
                  </div>
                  <div class="td-200-px">
                    دليل الخدمات الحكومية
                  </div>
                </div>
              </td>
              <td>
                <div class="tab-grey-box">
                  <div class="d-flex">
                    <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                  </div>
                  <div class="td-200-px">بعض الاسماء هنا</div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="tab-arrow">
                      <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">14</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/manage_accounts.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">03</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/contact_support.png" alt="loading">
                    <div>أسئلة شائعة</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div>Pending</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="plus-btn">
                      <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div class="tab-num">01</div>
                  </div>
                  <div class="tab-profile">
                    <img class="tab-profile-img" src="../../../../assets/icones-2025/Group-61302.png" alt="loading">
                  </div>
                  <div class="td-200-px">
                    دليل الخدمات الحكومية
                  </div>
                </div>
              </td>
              <td>
                <div class="tab-grey-box">
                  <div class="d-flex">
                    <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                  </div>
                  <div class="td-200-px">بعض الاسماء هنا</div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="tab-arrow">
                      <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">14</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/manage_accounts.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">03</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/contact_support.png" alt="loading">
                    <div>أسئلة شائعة</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div>Pending</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="plus-btn">
                      <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div class="tab-num">01</div>
                  </div>
                  <div class="tab-profile">
                    <img class="tab-profile-img" src="../../../../assets/icones-2025/Group-61302.png" alt="loading">
                  </div>
                  <div class="td-200-px">
                    دليل الخدمات الحكومية
                  </div>
                </div>
              </td>
              <td>
                <div class="tab-grey-box">
                  <div class="d-flex">
                    <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                  </div>
                  <div class="td-200-px">بعض الاسماء هنا</div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="tab-arrow">
                      <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">14</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/manage_accounts.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">03</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/contact_support.png" alt="loading">
                    <div>أسئلة شائعة</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div>Pending</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="plus-btn">
                      <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div class="tab-num">01</div>
                  </div>
                  <div class="tab-profile">
                    <img class="tab-profile-img" src="../../../../assets/icones-2025/Group-61302.png" alt="loading">
                  </div>
                  <div class="td-200-px">
                    دليل الخدمات الحكومية
                  </div>
                </div>
              </td>
              <td>
                <div class="tab-grey-box">
                  <div class="d-flex">
                    <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                  </div>
                  <div class="td-200-px">بعض الاسماء هنا</div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="tab-arrow">
                      <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">14</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/manage_accounts.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">03</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/contact_support.png" alt="loading">
                    <div>أسئلة شائعة</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div>Pending</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="plus-btn">
                      <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div class="tab-num">01</div>
                  </div>
                  <div class="tab-profile">
                    <img class="tab-profile-img" src="../../../../assets/icones-2025/Group-61302.png" alt="loading">
                  </div>
                  <div class="td-200-px">
                    دليل الخدمات الحكومية
                  </div>
                </div>
              </td>
              <td>
                <div class="tab-grey-box">
                  <div class="d-flex">
                    <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                  </div>
                  <div class="td-200-px">بعض الاسماء هنا</div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="tab-arrow">
                      <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">14</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/manage_accounts.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">03</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/contact_support.png" alt="loading">
                    <div>أسئلة شائعة</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div>Pending</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="plus-btn">
                      <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center">
                  <div class="d-flex">
                    <div class="tab-num">01</div>
                  </div>
                  <div class="tab-profile">
                    <img class="tab-profile-img" src="../../../../assets/icones-2025/Group-61302.png" alt="loading">
                  </div>
                  <div class="td-200-px">
                    دليل الخدمات الحكومية
                  </div>
                </div>
              </td>
              <td>
                <div class="tab-grey-box">
                  <div class="d-flex">
                    <img class="tab-icone" src="../../../../assets/icones-2025/account_circle.png" alt="loading">
                  </div>
                  <div class="td-200-px">بعض الاسماء هنا</div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="tab-arrow">
                      <img class="tab-icone" src="../../../../assets/icones-2025/arrow_cool_down.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10">
                  <div class="tab-grey-box-2">
                    <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                    <div>Jul - 27 -2024</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">14</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/manage_accounts.png" alt="loading">
                    <div>8:10 pm</div>
                  </div>
                  <div class="tab-grey-box-3">
                    <div class="tab-circle-num">03</div>
                    <img class="tab-icone" src="../../../../assets/icones-2025/contact_support.png" alt="loading">
                    <div>أسئلة شائعة</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-end gap-10 border-left">
                  <div class="tab-grey-box-3">
                    <div>Pending</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="plus-btn">
                      <img class="" src="../../../../assets/icones-2025/visibility.png" alt="loading">
                    </div>
                  </div>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
    <!-- table end -->
  </div>
  <!-- content end -->
  <!-- header code start -->
  <div class="mini-banner">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="pos-rel">
        <h3 class="mini-banner-text">إنشاء تقرير</h3>
      </div>
      <div class="back-arrow-btn">
        <img class="" src="../../../../assets/icones-2025/arrow_back.png" alt="loading">
      </div>
    </div>
  </div>
  <!-- header code end -->
  <!-- content start -->
  <div class="content-grey">
    <div class="row p-0">
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/apartment.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div>
            <input class="input-2025 my-2" type="text" id="title" placeholder="وزارة الاستثمار" formControlName="title"
              pInputText>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/person_2.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div>
            <input class="input-2025 my-2" type="text" id="title" placeholder="وزارة الاستثمار" formControlName="title"
              pInputText>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div class="d-flex">
            <div class="tab-white-box my-2">
              <div class="inner-data-border">
                <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                <div>Jul - 27 -2024</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
              <div class="inner-data">
                <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                <div>8:10 pm</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div class="d-flex">
            <div class="tab-white-box my-2">
              <div class="inner-data-border">
                <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                <div>Jul - 27 -2024</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
              <div class="inner-data">
                <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                <div>8:10 pm</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-white">
      <div class="d-flex align-items-center my-3">
        <div class="d-flex">
          <div class="plus-btn">
            <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
          </div>
        </div>
        <div class="d-flex">
          <p class="text">تم إضافة</p>
        </div>
        <div class="custom-hr"></div>
      </div>
      <div class="d-flex flex-wrap">
        <div class="blue-num-btn">
          <div class="d-flex">
            <div class="btn-num">
              14
            </div>
          </div>
          <div class="d-flex align-items-center mx-2">
            <img class="" src="../../../../assets/icones-2025/draft.png" alt="loading">
          </div>
          <div class="d-flex">
            <label class="cursor">أسئلة شائعة</label>
          </div>
        </div>
        <div class="blue-num-btn">
          <div class="d-flex">
            <div class="btn-num">
              14
            </div>
          </div>
          <div class="d-flex align-items-center mx-2">
            <img class="" src="../../../../assets/icones-2025/draft.png" alt="loading">
          </div>
          <div class="d-flex">
            <label class="cursor">أسئلة شائعة</label>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center my-3">
        <div class="d-flex">
          <div class="plus-btn">
            <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
          </div>
        </div>
        <div class="d-flex">
          <p class="text">تم إضافة</p>
        </div>
        <div class="custom-hr"></div>
      </div>
      <div class="d-flex align-items-center my-3">
        <div class="d-flex">
          <div class="plus-btn">
            <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
          </div>
        </div>
        <div class="d-flex">
          <p class="text">تم إضافة</p>
        </div>
        <div class="custom-hr"></div>
      </div>
    </div>
    <div class="content-white">
      <p class="text-300">تأكيد كلمة المرور الجديدة
        تأكيد كلمة المرور الجديدة</p>
      <div class="d-flex">
        <div class="yes-btn">
          <div class="d-flex">
            <input class="form-check-input" type="radio" name="flexRadioDefault">
          </div>
          <div class="d-flex">
            <label class="cursor">نعم</label>
          </div>
        </div>
        <div class="no-btn">
          <div class="d-flex">
            <input class="form-check-input" type="radio" name="flexRadioDefault">
          </div>
          <div class="d-flex">
            <label class="cursor">لا</label>
          </div>
        </div>
      </div>
    </div>
    <div class="content-white">
      <p class="text-300">تأكيد كلمة المرور الجديدة
        تأكيد كلمة المرور الجديدة</p>
      <div class="form-floating">
        <textarea class="form-control custom-textarea" placeholder="Leave a comment here" id="floatingTextarea2"
          style="height: 100px"></textarea>
      </div>
    </div>
    <div class="content-white">
      <p class="text-300">تأكيد كلمة المرور الجديدة
        تأكيد كلمة المرور الجديدة</p>
      <div class="text-radio-bar">
        <div class="d-flex">
          <input class="form-check-input" type="radio" name="flexRadioDefault">
        </div>
        قر بأن جميع المعلومات صحيحة وموثوقة ويمكن نشرها واعتمادها للرد على اسفسارات المستثمرين
      </div>
    </div>
    <div class="d-flex">
      <div class="submit-blue-btn">
        <div class="d-flex align-items-center">
          <img cl ass="" src="../../../../assets/icones-2025/check_small.png" alt="loading">
        </div>
        موافق
      </div>
    </div>
  </div>
  <!-- content end -->
  <!-- header code start -->
  <div class="mini-banner">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="pos-rel">
        <h3 class="mini-banner-text">إنشاء تقرير</h3>
      </div>
      <div class="back-arrow-btn">
        <img class="" src="../../../../assets/icones-2025/arrow_back.png" alt="loading">
      </div>
    </div>
  </div>
  <!-- header code end -->
  <!-- content start -->
  <div class="content-grey">
    <div class="row p-0">
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/apartment.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div>
            <input class="input-2025 my-2" type="text" id="title" placeholder="وزارة الاستثمار" formControlName="title"
              pInputText>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/person_2.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div>
            <input class="input-2025 my-2" type="text" id="title" placeholder="وزارة الاستثمار" formControlName="title"
              pInputText>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-12">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <img src="../../../../assets/icones-2025/calendar_today.png" alt="loading">
            <label class="label-ui">تاريخ البدء</label>
          </div>
          <div class="d-flex">
            <div class="tab-white-box my-2">
              <div class="inner-data-border">
                <img class="tab-icone" src="../../../../assets/icones-2025/calendar_today (2).png" alt="loading">
                <div>Jul - 27 -2024</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
              <div class="inner-data">
                <img class="tab-icone" src="../../../../assets/icones-2025/schedule.png" alt="loading">
                <div>8:10 pm</div>
                <img class="width-15px" src="../../../../assets/icones-2025/arrow_back_ios.png" alt="loading">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row p-0">
      <div class="col-lg-6 col-md-6 col-12">
        <div class="content-white-height">
          <div class="d-flex align-items-center my-3">
            <div class="d-flex">
              <div class="plus-btn">
                <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
              </div>
            </div>
            <div class="d-flex">
              <p class="text">تم إضافة</p>
            </div>
            <div class="custom-hr"></div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="blue-num-btn">
              <div class="d-flex">
                <div class="btn-num">
                  14
                </div>
              </div>
              <div class="d-flex align-items-center mx-2">
                <img class="" src="../../../../assets/icones-2025/draft.png" alt="loading">
              </div>
              <div class="d-flex">
                <label class="cursor">أسئلة شائعة</label>
              </div>
            </div>
            <div class="blue-num-btn">
              <div class="d-flex">
                <div class="btn-num">
                  14
                </div>
              </div>
              <div class="d-flex align-items-center mx-2">
                <img class="" src="../../../../assets/icones-2025/draft.png" alt="loading">
              </div>
              <div class="d-flex">
                <label class="cursor">أسئلة شائعة</label>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center my-3">
            <div class="d-flex">
              <div class="plus-btn">
                <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
              </div>
            </div>
            <div class="d-flex">
              <p class="text">تم إضافة</p>
            </div>
            <div class="custom-hr"></div>
          </div>
          <div class="d-flex align-items-center my-3">
            <div class="d-flex">
              <div class="plus-btn">
                <img class="" src="../../../../assets/icones-2025/add.png" alt="loading">
              </div>
            </div>
            <div class="d-flex">
              <p class="text">تم إضافة</p>
            </div>
            <div class="custom-hr"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12">
        <div class="content-white">
          <p class="text-300">تأكيد كلمة المرور الجديدة
            تأكيد كلمة المرور الجديدة</p>
          <div class="d-flex">
            <div class="yes-btn">
              <div class="d-flex">
                <input class="form-check-input" type="radio" name="flexRadioDefault">
              </div>
              <div class="d-flex">
                <label class="cursor">نعم</label>
              </div>
            </div>
            <div class="no-btn">
              <div class="d-flex">
                <input class="form-check-input" type="radio" name="flexRadioDefault">
              </div>
              <div class="d-flex">
                <label class="cursor">لا</label>
              </div>
            </div>
          </div>
        </div>
        <div class="content-white">
          <p class="text-300">تأكيد كلمة المرور الجديدة
            تأكيد كلمة المرور الجديدة</p>
          <div class="form-floating">
            <textarea class="form-control custom-textarea" placeholder="Leave a comment here" id="floatingTextarea2"
              style="height: 100px"></textarea>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-12">
        <div class="content-white">
          <p class="text-300">تأكيد كلمة المرور الجديدة
            تأكيد كلمة المرور الجديدة</p>
          <div class="text-radio-bar">
            <div class="d-flex">
              <input class="form-check-input" type="radio" name="flexRadioDefault">
            </div>
            قر بأن جميع المعلومات صحيحة وموثوقة ويمكن نشرها واعتمادها للرد على اسفسارات المستثمرين
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="submit-blue-btn">
        <div class="d-flex align-items-center">
          <img cl ass="" src="../../../../assets/icones-2025/check_small.png" alt="loading">
        </div>
        موافق
      </div>
    </div>
  </div>
  <!-- content end -->
</div>
<!-- osama 3 pages design end -->
<app-footer></app-footer>